// @ts-nocheck
/**
 * Nexode Air：`nexode-air-template-section`；依赖 gsap / ScrollTrigger；无 CE API 则整段不注册。
 */
(function () {
  'use strict';

  const TAG_NAME = 'nexode-air-template-section';
  const FORM_SUBMIT_URL = 'https://ecf.cirkleinc.com/api/form-submit';
  const MOBILE_MQ = '(max-width: 1023.98px)';
  const AIR65_FRAME_EPS = 0.002;
  const AIR65_PRELOAD_HIGH_COUNT_DESKTOP = 16;
  const AIR65_PRELOAD_HIGH_COUNT_MOBILE = 6;
  const AIR65_DESC_REVEAL_START_FRAME = 100;
  const AIR65_DESC_REVEAL_SPAN = 12;
  const AIR65_HOLD_LAST_VH = 1;
  const AIR65_COMBO_PHASE1_END = 0.4;
  const AIR65_COMBO_PHASE2_END = 0.6;
  const AIR65_COMBO_SCROLL_VHS = 5.2;
  const AIR65_COMBO_DIM_MAX = 0.7;
  /** ScrollTrigger scrub 滞后（秒），多处共用；越小越跟手 */
  const NA_SCROLL_SCRUB_LAG_SEC = 0.1;
  const NA_CHARGE_PROMO_SCRUB_SEC = 0.02;
  const AIR65_PB_COPY_TAIL_VH = 1.45;
  const AIR65_COMBO_PB_PHASE3_FRAME_FRAC = 0.72;
  const AIR65_PB_COPY_IN_DURATION = 1.06;
  const AIR65_PB_COPY_IN_STAGGER = 0.26;
  const NA_SCROLL_REVEAL_START = 'top 70%';
  let nexodeAirRefreshRaf = 0;

  function scheduleNexodeAirTemplateScrollTriggerRefresh() {
    const ScrollTrigger = window.ScrollTrigger;
    if (!ScrollTrigger || typeof ScrollTrigger.refresh !== 'function') return;
    if (nexodeAirRefreshRaf) return;
    nexodeAirRefreshRaf = window.requestAnimationFrame(() => {
      nexodeAirRefreshRaf = 0;
      try {
        ScrollTrigger.refresh();
      } catch (_) {}
    });
  }

  const REVEAL_DEFAULTS = Object.freeze({
    y: 26,
    duration: 0.88,
    ease: 'power2.out',
    start: NA_SCROLL_REVEAL_START,
    stagger: 0.18
  });

  /** 静音 + playsInline；iOS 须 H.264（WebM 常不可播） */
  function naPrimeInlineVideoForAutoplay(video) {
    if (!(video instanceof HTMLVideoElement)) return;
    try {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('x5-playsinline', '');
    } catch (_) {}
  }

  function naTryPlayInlineVideo(video) {
    if (!(video instanceof HTMLVideoElement)) return;
    naPrimeInlineVideoForAutoplay(video);
    const run = () => {
      try {
        const p = video.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
      } catch (_) {}
    };
    if (video.readyState >= 2) {
      window.requestAnimationFrame(() => window.requestAnimationFrame(run));
      return;
    }
    const once = () => {
      window.requestAnimationFrame(() => window.requestAnimationFrame(run));
    };
    video.addEventListener('loadeddata', once, { once: true });
    video.addEventListener('canplay', once, { once: true });
    try {
      video.load();
    } catch (_) {}
  }

  /** 不调用 load()，避免重置缓冲（KV 断点切换）；未就绪则等 loadeddata/canplay */
  function naPlayBufferedInlineVideo(video) {
    if (!(video instanceof HTMLVideoElement)) return;
    naPrimeInlineVideoForAutoplay(video);
    const run = () => {
      try {
        const p = video.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
      } catch (_) {}
    };
    const schedule = () => {
      window.requestAnimationFrame(() => window.requestAnimationFrame(run));
    };
    if (video.readyState >= 2) {
      schedule();
      return;
    }
    const once = () => {
      schedule();
    };
    video.addEventListener('loadeddata', once, { once: true });
    video.addEventListener('canplay', once, { once: true });
  }

  function naObserveAndRetryVideoPlay(video) {
    if (!(video instanceof HTMLVideoElement)) return () => {};
    naTryPlayInlineVideo(video);
    if (typeof IntersectionObserver === 'undefined') return () => {};
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) naTryPlayInlineVideo(video);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -4% 0px' }
    );
    io.observe(video);
    return () => {
      try {
        io.disconnect();
      } catch (_) {}
    };
  }

  if (
    typeof customElements === 'undefined' ||
    typeof customElements.get !== 'function' ||
    typeof customElements.define !== 'function'
  ) {
    return;
  }
  try {
  if (customElements.get(TAG_NAME)) {
      return;
    }
  } catch (_) {
    return;
  }

  function initNexodeAirTemplateScrollReveal(root) {
    const gsap = window.gsap;
    const ScrollTrigger = window.ScrollTrigger;
    const registered = [];
    const markRevealTrigger = (st) => {
      if (!st || typeof st !== 'object') return;
      try {
        st.__naReveal = true;
      } catch (_) {}
    };

    if (!gsap || !ScrollTrigger) {
      return function noop() {};
    }

    gsap.registerPlugin(ScrollTrigger);

    const reduced =
      typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced) {
      root
        .querySelectorAll('[data-na-reveal], [data-na-reveal-stagger] [data-na-reveal], [data-na-es-steps-stagger] [data-na-reveal]')
        .forEach((el) => {
        if (el instanceof HTMLElement) {
          el.style.opacity = '1';
          el.style.transform = 'none';
            el.classList.add('is-revealed');
          }
        });
      root.querySelectorAll('[data-na-es-steps-stagger]').forEach((el) => {
        if (el instanceof HTMLElement) {
          el.classList.add('is-es-steps-line-visible');
        }
      });
      return function noop() {};
    }

    const fromVars = { opacity: 0, y: REVEAL_DEFAULTS.y };
    const { duration, ease, start, stagger } = REVEAL_DEFAULTS;

    const esStepsMobile =
      typeof window.matchMedia === 'function' && window.matchMedia(MOBILE_MQ).matches;
    const esStepsFrom = esStepsMobile
      ? { opacity: 0, x: 0, y: REVEAL_DEFAULTS.y }
      : { opacity: 0, x: -28, y: 0 };

    root.querySelectorAll('[data-na-es-steps-stagger]').forEach((staggerRoot) => {
      if (!(staggerRoot instanceof HTMLElement)) return;
      const children = staggerRoot.querySelectorAll(':scope > [data-na-reveal]');
      if (!children.length) return;

      gsap.set(children, esStepsFrom);
      const tween = gsap.to(children, {
        opacity: 1,
        x: 0,
        y: 0,
        duration,
        stagger,
        ease,
        onComplete: () => {
          children.forEach((child) => {
            if (child instanceof HTMLElement) {
              child.classList.add('is-revealed');
            }
          });
          staggerRoot.classList.add('is-es-steps-line-visible');
        },
        scrollTrigger: {
          trigger: staggerRoot,
          start,
          toggleActions: 'play none none none'
        }
      });
      if (tween.scrollTrigger) {
        markRevealTrigger(tween.scrollTrigger);
        registered.push(tween.scrollTrigger);
      }
    });

    root.querySelectorAll('[data-na-reveal-stagger]').forEach((staggerRoot) => {
      if (!(staggerRoot instanceof HTMLElement)) return;
      const children = staggerRoot.querySelectorAll(':scope > [data-na-reveal]');
      if (!children.length) return;

      gsap.set(children, fromVars);
      const tween = gsap.to(children, {
        opacity: 1,
        y: 0,
        duration,
        stagger,
        ease,
        onComplete: () => {
          children.forEach((child) => {
            if (child instanceof HTMLElement) {
              child.classList.add('is-revealed');
            }
          });
        },
        scrollTrigger: {
          trigger: staggerRoot,
          start,
          toggleActions: 'play none none none'
        }
      });
      if (tween.scrollTrigger) {
        markRevealTrigger(tween.scrollTrigger);
        registered.push(tween.scrollTrigger);
      }
    });

    root.querySelectorAll('[data-na-reveal]').forEach((el) => {
      if (!(el instanceof HTMLElement)) return;
      if (el.closest('[data-na-reveal-stagger]')) return;
      if (el.closest('[data-na-es-steps-stagger]')) return;

      gsap.set(el, fromVars);
      const tween = gsap.to(el, {
        opacity: 1,
        y: 0,
        duration,
        ease,
        onComplete: () => {
          el.classList.add('is-revealed');
        },
        scrollTrigger: {
          trigger: el,
          start,
          toggleActions: 'play none none none'
        }
      });
      if (tween.scrollTrigger) {
        markRevealTrigger(tween.scrollTrigger);
        registered.push(tween.scrollTrigger);
      }
    });

    if (!reduced) {
      const emailIconFrom = { autoAlpha: 0, y: 26, scale: 0.992 };
      const emailIconEase = 'power3.out';
      const emailIconDuration = 0.88;
      const emailIconStart = NA_SCROLL_REVEAL_START;

      root.querySelectorAll('[data-na-email-input-icon]').forEach((icon) => {
        if (!(icon instanceof HTMLElement)) return;
        const trigger =
          icon.closest('.ug-nexode-air-template__email-row') ||
          icon.closest('.ug-nexode-air-template__email-form') ||
          root;
        gsap.set(icon, emailIconFrom);
        const tween = gsap.to(icon, {
          autoAlpha: 1,
          y: 0,
          scale: 1,
          duration: emailIconDuration,
          ease: emailIconEase,
          scrollTrigger: {
            trigger,
            start: emailIconStart,
            once: true
          }
        });
        if (tween.scrollTrigger) {
          markRevealTrigger(tween.scrollTrigger);
          registered.push(tween.scrollTrigger);
        }
      });
    } else {
      root.querySelectorAll('[data-na-email-input-icon]').forEach((icon) => {
        if (icon instanceof HTMLElement) {
          icon.style.opacity = '1';
          icon.style.transform = 'none';
        }
      });
    }

    scheduleNexodeAirTemplateScrollTriggerRefresh();

    return function cleanup() {
      registered.forEach((st) => {
        try {
          st.kill();
        } catch (_) {}
      });
      registered.length = 0;
    };
  }

  function refreshNexodeAirTemplateScrollReveal(root) {
    const ST = window.ScrollTrigger;
    if (!(root instanceof HTMLElement) || typeof ST === 'undefined') {
      return function noop() {};
    }
    ST.getAll().forEach((st) => {
      if (st.__naReveal && st.trigger && root.contains(/** @type {Node} */ (st.trigger))) {
        st.kill();
      }
    });
    return initNexodeAirTemplateScrollReveal(root);
  }

  function nexodeAirTabLabelColorForBg(bg) {
    if (!bg || typeof bg !== 'string') return '#ffffff';
    const s = bg.trim();
    let r = 133;
    let g = 134;
    let b = 148;
    const hex = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(s);
    if (hex) {
      let h = hex[1];
      if (h.length === 3) {
        h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
      }
      r = parseInt(h.slice(0, 2), 16);
      g = parseInt(h.slice(2, 4), 16);
      b = parseInt(h.slice(4, 6), 16);
    } else if (/^rgba?\(/i.test(s)) {
      const m = s.match(/\d+(\.\d+)?/g);
      if (m && m.length >= 3) {
        r = Math.min(255, Math.round(Number(m[0])));
        g = Math.min(255, Math.round(Number(m[1])));
        b = Math.min(255, Math.round(Number(m[2])));
      }
    }
    const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return lum > 0.62 ? '#191a1a' : '#ffffff';
  }

  function buildNexodeAirTemplateFrameUrl(prefix, index, pad, ext) {
    return prefix + String(index).padStart(pad, '0') + '.' + ext;
  }

  function naAir65PbEndCopyHelpers(copyRoot, ctx) {
    const gsap = window.gsap;
    const reduced = !!(ctx && ctx.reduced);
    const copyHeading =
      copyRoot instanceof HTMLElement ? copyRoot.querySelector('.ug-nexode-air-template__air65-title') : null;
    const copyDesc =
      copyRoot instanceof HTMLElement ? copyRoot.querySelector('.ug-nexode-air-template__air65-desc') : null;
    const headingHighlights =
      copyHeading instanceof HTMLElement
        ? Array.from(copyHeading.querySelectorAll('b, strong')).filter((el) => el instanceof HTMLElement)
        : [];
    const lineSel = '.ug-nexode-air-template__air65-title, .ug-nexode-air-template__air65-desc';
    const copyLines =
      copyRoot instanceof HTMLElement
        ? Array.from(copyRoot.querySelectorAll(lineSel)).filter((el) => el instanceof HTMLElement)
        : [];

    const applyHidden = () => {
      if (!gsap) return;
      if (reduced) {
        if (copyLines.length) {
          gsap.set(copyLines, { autoAlpha: 1, y: 0, filter: 'blur(0px)' });
        } else if (copyHeading && copyDesc) {
          gsap.set([copyHeading, copyDesc], { autoAlpha: 1, y: 0, filter: 'blur(0px)' });
        }
        if (copyHeading instanceof HTMLElement) copyHeading.classList.add('is-revealed');
        headingHighlights.forEach((el) => el.style.setProperty('--na-title-reveal', '100%'));
        return;
      }
      if (copyLines.length) {
        gsap.set(copyLines, { autoAlpha: 0, y: 28, filter: 'blur(0px)' });
      } else if (copyHeading instanceof HTMLElement && copyDesc instanceof HTMLElement) {
        gsap.set([copyHeading, copyDesc], { autoAlpha: 0, y: 28, filter: 'blur(0px)' });
      }
      if (copyHeading instanceof HTMLElement) copyHeading.classList.remove('is-revealed');
      headingHighlights.forEach((el) => {
        el.style.setProperty('--na-title-reveal', '0%');
      });
    };

    const killCopyTweens = () => {
      if (!gsap) return;
      if (copyLines.length) gsap.killTweensOf(copyLines);
      if (headingHighlights.length) gsap.killTweensOf(headingHighlights);
    };

    const playEndReveal = (onComplete) => {
      if (!gsap) {
        if (typeof onComplete === 'function') onComplete();
        return;
      }
      if (reduced) {
        applyHidden();
        if (typeof onComplete === 'function') onComplete();
        return;
      }
      killCopyTweens();
      if (!(copyHeading instanceof HTMLElement) || !(copyDesc instanceof HTMLElement)) {
        if (typeof onComplete === 'function') onComplete();
        return;
      }
      gsap.set(copyHeading, { autoAlpha: 1, y: 0, filter: 'blur(0px)' });
      const tl = gsap.timeline({
        onComplete: typeof onComplete === 'function' ? onComplete : undefined
      });
      tl.fromTo(
        copyDesc,
        { autoAlpha: 0, y: 28, filter: 'blur(0px)' },
        { autoAlpha: 1, y: 0, duration: AIR65_PB_COPY_IN_DURATION, ease: 'power2.out' }
      );
      tl.add(() => {
        copyHeading.classList.add('is-revealed');
        headingHighlights.forEach((el) => {
          el.style.setProperty('--na-title-reveal', '0%');
        });
      });
      if (headingHighlights.length) {
        tl.to(headingHighlights, {
          duration: 0.55,
          ease: 'power2.out',
          '--na-title-reveal': '100%'
        });
      }
    };

    return { applyHidden, killCopyTweens, playEndReveal, copyLines, copyHeading };
  }

  function naAir65FindNextMaskWipeSection(holdSection) {
    const parent = holdSection.parentElement;
    if (!(parent instanceof HTMLElement)) return null;
    const kids = Array.from(parent.children);
    const idx = kids.indexOf(holdSection);
    if (idx < 0 || idx >= kids.length - 1) return null;
    for (let i = idx + 1; i < kids.length; i += 1) {
      const n = kids[i];
      if (!(n instanceof HTMLElement)) continue;
      const tag = n.tagName;
      if (tag === 'LINK' || tag === 'STYLE' || tag === 'SCRIPT' || tag === 'NOSCRIPT') continue;
      const maskRaw =
        (n.matches('[data-na-air65]') && n.getAttribute('data-air65-mask-wipe')) || '';
      const isPb =
        n.matches('[data-na-air65]') &&
        (maskRaw === '1' ||
          maskRaw === 'true' ||
          n.dataset.air65MaskWipe === '1' ||
          n.dataset.air65MaskWipe === 'true');
      if (isPb) return n;
      return null;
    }
    return null;
  }

  function naAir65HoldImmediatelyPrecedesSection(holdSection, wipeSection) {
    if (!(holdSection instanceof HTMLElement) || !(wipeSection instanceof HTMLElement)) return false;
    const p1 = holdSection.parentElement;
    if (!(p1 instanceof HTMLElement) || p1 !== wipeSection.parentElement) return false;
    const kids = Array.from(p1.children);
    const pbIdx = kids.indexOf(wipeSection);
    if (pbIdx <= 0) return false;
    for (let i = pbIdx - 1; i >= 0; i -= 1) {
      const n = kids[i];
      if (!(n instanceof HTMLElement)) continue;
      const tag = n.tagName;
      if (tag === 'LINK' || tag === 'STYLE' || tag === 'SCRIPT' || tag === 'NOSCRIPT') continue;
      return n === holdSection;
    }
    return false;
  }

  function naAir65BuildFrameDrawApi(section, ctx, opts) {
    const gsap = window.gsap;
    const { cleanups, reduced } = ctx;
    const pbDeferCopyReveal = !!(opts && opts.pbDeferCopyReveal);
    const isAir65Mobile =
      typeof window.matchMedia === 'function' && window.matchMedia(MOBILE_MQ).matches;
    const moVideoUrl = (section.dataset.air65MoVideo || '').trim();
    const moVideoEl = section.querySelector('[data-na-air65-mo-video]');
    if (isAir65Mobile && moVideoUrl && moVideoEl instanceof HTMLVideoElement) {
      return null;
    }
    const pin = section.querySelector('.ug-nexode-air-template__air65-pin');
    const stage = section.querySelector('.ug-nexode-air-template__air65-stage');
    const copy = section.querySelector('[data-na-air65-copy]');
    const canvas = section.querySelector('[data-na-air65-canvas]');
    const poster = section.querySelector('[data-na-air65-poster]');
    const copyHeading =
      copy instanceof HTMLElement ? copy.querySelector('.ug-nexode-air-template__air65-title') : null;
    const copyDesc =
      copy instanceof HTMLElement ? copy.querySelector('.ug-nexode-air-template__air65-desc') : null;
    const headingHighlights =
      copyHeading instanceof HTMLElement
        ? Array.from(copyHeading.querySelectorAll('b, strong')).filter((el) => el instanceof HTMLElement)
        : [];
    const prefix = section.dataset.framePrefix || '';
    const count = Number.parseInt(section.dataset.frameCount || '0', 10);
    const padW = Number.parseInt(section.dataset.framePad || '3', 10);
    const ext = section.dataset.frameExt || 'webp';

    if (
      !(pin instanceof HTMLElement) ||
      !(stage instanceof HTMLElement) ||
      !(canvas instanceof HTMLCanvasElement) ||
      !prefix ||
      !count ||
      !gsap
    ) {
      return null;
    }

    const ctx2d = canvas.getContext('2d');
    if (!ctx2d) return null;

    const clamp01 = (n) => Math.max(0, Math.min(1, n));
    let air65TitleGradientShown = false;
    const pbEndCopy =
      pbDeferCopyReveal && copy instanceof HTMLElement ? naAir65PbEndCopyHelpers(copy, ctx) : null;

    const applyAir65CopyFrameReveal = (frameIndex) => {
      if (!(copyHeading instanceof HTMLElement) || !(copyDesc instanceof HTMLElement)) return;
      if (reduced) {
        gsap.set(copyHeading, { autoAlpha: 1, y: 0, filter: 'blur(0px)' });
        gsap.set(copyDesc, { autoAlpha: 1, y: 0, filter: 'blur(0px)' });
        copyHeading.classList.add('is-revealed');
        headingHighlights.forEach((el) => {
          el.style.setProperty('--na-title-reveal', '100%');
        });
        return;
      }
      const descT = clamp01((frameIndex - AIR65_DESC_REVEAL_START_FRAME) / AIR65_DESC_REVEAL_SPAN);
      gsap.set(copyHeading, { autoAlpha: 1, y: 0, filter: 'blur(0px)' });
      gsap.set(copyDesc, {
        autoAlpha: descT,
        y: 12 * (1 - descT),
        filter: 'blur(' + (12 * (1 - descT)).toFixed(2) + 'px)'
      });
      const descFullyShown = descT >= 1 - AIR65_FRAME_EPS;
      if (descFullyShown) {
        copyHeading.classList.add('is-revealed');
        if (!air65TitleGradientShown) {
          air65TitleGradientShown = true;
          headingHighlights.forEach((el) => {
            el.style.setProperty('--na-title-reveal', '0%');
          });
          if (headingHighlights.length) {
            gsap.killTweensOf(headingHighlights);
            gsap.to(headingHighlights, {
              duration: 0.55,
              ease: 'power2.out',
              '--na-title-reveal': '100%'
            });
          }
        }
      } else {
        if (air65TitleGradientShown && headingHighlights.length) {
          gsap.killTweensOf(headingHighlights);
        }
        air65TitleGradientShown = false;
        copyHeading.classList.remove('is-revealed');
        headingHighlights.forEach((el) => {
          el.style.setProperty('--na-title-reveal', '0%');
        });
      }
    };

    const frames = [];
    const imageSequence = { frame: 0 };

    const resolveRenderableFrame = (targetIndex) => {
      const safeIndex = Math.min(count - 1, Math.max(0, targetIndex));
      const direct = frames[safeIndex];
      if (direct && direct.complete && direct.naturalWidth) return direct;
      for (let prev = safeIndex - 1; prev >= 0; prev -= 1) {
        const prevFrame = frames[prev];
        if (prevFrame && prevFrame.complete && prevFrame.naturalWidth) return prevFrame;
      }
      for (let next = safeIndex + 1; next < count; next += 1) {
        const nextFrame = frames[next];
        if (nextFrame && nextFrame.complete && nextFrame.naturalWidth) return nextFrame;
      }
      return null;
    };

    const applyCanvasBufferSize = () => {
      const w = stage.offsetWidth;
      const h = stage.offsetHeight;
      if (w <= 0 || h <= 0) return;
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const bw = Math.max(1, Math.round(w * dpr));
      const bh = Math.max(1, Math.round(h * dpr));
      if (canvas.width !== bw || canvas.height !== bh) {
        canvas.width = bw;
        canvas.height = bh;
      }
    };

    const renderCanvas = () => {
      const frameIndex = Math.min(count - 1, Math.max(0, Math.round(imageSequence.frame)));
      const frame = resolveRenderableFrame(frameIndex);
      if (!frame) return;
      applyCanvasBufferSize();
      const ctx = ctx2d;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      const scale = Math.max(canvas.width / frame.naturalWidth, canvas.height / frame.naturalHeight);
      const drawWidth = frame.naturalWidth * scale;
      const drawHeight = frame.naturalHeight * scale;
      const drawX = (canvas.width - drawWidth) / 2;
      const drawY = (canvas.height - drawHeight) / 2;
      ctx.drawImage(frame, drawX, drawY, drawWidth, drawHeight);
      if (poster instanceof HTMLElement) {
        poster.classList.add('is-hidden');
      }
    };

    for (let i = 0; i < count; i += 1) {
      const img = new Image();
      img.decoding = 'async';
      if ('fetchPriority' in img) {
        img.fetchPriority = i < AIR65_PRELOAD_HIGH_COUNT_DESKTOP ? 'high' : 'low';
      }
      if (i === 0) {
        img.onload = function () {
          renderCanvas();
          scheduleNexodeAirTemplateScrollTriggerRefresh();
        };
      } else {
        img.onload = () => {
          const cur = Math.round(imageSequence.frame);
          if (Math.abs(i - cur) <= 1) {
            renderCanvas();
          }
        };
      }
      img.src = buildNexodeAirTemplateFrameUrl(prefix, i + 1, padW, ext);
      frames[i] = img;
    }
    renderCanvas();

    const resizeDraw = () => {
      renderCanvas();
    };

    const onAir65WindowResize = () => {
      resizeDraw();
    };
    window.addEventListener('resize', onAir65WindowResize, { passive: true });
    cleanups.push(() => window.removeEventListener('resize', onAir65WindowResize));

    let ro = null;
      if (typeof ResizeObserver === 'function') {
      ro = new ResizeObserver(() => {
        resizeDraw();
      });
      ro.observe(stage);
        cleanups.push(() => {
          try {
          ro.disconnect();
          } catch (_) {}
        });
      }

    let lastRenderedFrameIndex = -1;
    const setUnitProgress = (unit01) => {
      const frameT = Math.max(0, Math.min(1, unit01));
      let nextFrameIndex;
      if (frameT <= AIR65_FRAME_EPS) {
        nextFrameIndex = 0;
      } else if (frameT >= 1 - AIR65_FRAME_EPS) {
        nextFrameIndex = count - 1;
      } else {
        nextFrameIndex = Math.min(
          count - 1,
          Math.max(0, Math.round((count - 1) * frameT))
        );
      }
      if (nextFrameIndex !== lastRenderedFrameIndex) {
        lastRenderedFrameIndex = nextFrameIndex;
        imageSequence.frame = nextFrameIndex;
        renderCanvas();
      }
      if (!pbDeferCopyReveal) {
        applyAir65CopyFrameReveal(nextFrameIndex);
      }
    };

    if (pbEndCopy && pbDeferCopyReveal) {
      pbEndCopy.applyHidden();
    }

    return {
      section,
      setUnitProgress,
      resize: resizeDraw,
      applyPbCopyHidden: pbDeferCopyReveal && pbEndCopy ? pbEndCopy.applyHidden : undefined,
      playPbCopyEndReveal: pbDeferCopyReveal && pbEndCopy ? pbEndCopy.playEndReveal : undefined,
      killCopyTweens: pbDeferCopyReveal && pbEndCopy ? pbEndCopy.killCopyTweens : undefined
    };
  }

  function naAir65TryInitWpbCombo(sec65, secPb, ctx) {
    const gsap = window.gsap;
    const ScrollTrigger = window.ScrollTrigger;
    const { cleanups, registered, reduced } = ctx;
    if (
      (typeof window.matchMedia === 'function' && window.matchMedia(MOBILE_MQ).matches) ||
      !(sec65 instanceof HTMLElement) ||
      !(secPb instanceof HTMLElement) ||
      !gsap ||
      !ScrollTrigger ||
      reduced
    ) {
      return false;
    }

    const api65 = naAir65BuildFrameDrawApi(sec65, ctx);
    const apiPb = naAir65BuildFrameDrawApi(secPb, ctx, { pbDeferCopyReveal: true });
    if (!api65 || !apiPb) {
      return false;
    }

    const pin65 = sec65.querySelector('.ug-nexode-air-template__air65-pin');
    const inner65 = sec65.querySelector('.ug-nexode-air-template__air65-inner');
    if (!(pin65 instanceof HTMLElement) || !(inner65 instanceof HTMLElement)) {
      return false;
    }

    const dim = document.createElement('div');
    dim.className = 'ug-nexode-air-template__air65-combo-dim';
    dim.setAttribute('aria-hidden', 'true');
    inner65.appendChild(dim);

    const parent = sec65.parentElement;
    if (!(parent instanceof HTMLElement)) {
      try {
        if (dim.parentNode) dim.parentNode.removeChild(dim);
        } catch (_) {}
      return false;
    }

    const c01 = (n) => Math.max(0, Math.min(1, n));

    const comboScroll = document.createElement('div');
    const comboSticky = document.createElement('div');
    const comboStack = document.createElement('div');
    comboScroll.className = 'ug-nexode-air-template__air65-combo-scroll';
    comboSticky.className = 'ug-nexode-air-template__air65-combo-sticky';
    comboStack.className = 'ug-nexode-air-template__air65-combo-stack';

    parent.insertBefore(comboScroll, sec65);
    comboScroll.appendChild(comboSticky);
    comboSticky.appendChild(comboStack);
    comboStack.appendChild(sec65);
    comboStack.appendChild(secPb);

    sec65.classList.add('is-air65-combo-screen', 'is-air65-combo-screen--base');
    secPb.classList.add('is-air65-combo-screen', 'is-air65-combo-screen--cover');

    pin65.classList.add('is-air65-combo-dim-host');

    const P1 = AIR65_COMBO_PHASE1_END;
    const P2 = AIR65_COMBO_PHASE2_END;
    let pbComboTailActive = false;

    const syncComboHeight = () => {
      const vh = Math.max(
        typeof window.innerHeight === 'number' ? window.innerHeight : 0,
        800
      );
      comboScroll.style.height = Math.round(AIR65_COMBO_SCROLL_VHS * vh) + 'px';
    };
    syncComboHeight();

    const applyComboProgress = (p) => {
      const pr = Math.max(0, Math.min(1, typeof p === 'number' ? p : 0));
      let u65 = 0;
      let uPb = 0;
      let dimA = 0;
      if (pbComboTailActive && pr <= P2 + 1e-12) {
        pbComboTailActive = false;
        if (typeof apiPb.applyPbCopyHidden === 'function') apiPb.applyPbCopyHidden();
        if (typeof apiPb.killCopyTweens === 'function') apiPb.killCopyTweens();
      }
      if (pr <= P1 + 1e-12) {
        u65 = P1 <= 1e-9 ? 1 : pr / P1;
        uPb = 0;
        dimA = 0;
        secPb.style.top = '100%';
      } else if (pr <= P2 + 1e-12) {
        u65 = 1;
        uPb = 0;
        const span = Math.max(P2 - P1, 1e-9);
        const cov = c01((pr - P1) / span);
        dimA = cov * AIR65_COMBO_DIM_MAX;
        secPb.style.top = Math.round((1 - cov) * 10000) / 100 + '%';
      } else {
        u65 = 1;
        const span = Math.max(1 - P2, 1e-9);
        const p3 = c01((pr - P2) / span);
        const fShare = AIR65_COMBO_PB_PHASE3_FRAME_FRAC;
        dimA = AIR65_COMBO_DIM_MAX;
        secPb.style.top = '0%';
        if (p3 < fShare - 1e-12) {
          uPb = fShare <= 1e-9 ? 1 : p3 / fShare;
          if (pbComboTailActive) {
            pbComboTailActive = false;
            if (typeof apiPb.applyPbCopyHidden === 'function') apiPb.applyPbCopyHidden();
            if (typeof apiPb.killCopyTweens === 'function') apiPb.killCopyTweens();
          }
        } else {
          uPb = 1;
          if (!pbComboTailActive) {
            pbComboTailActive = true;
            if (typeof apiPb.playPbCopyEndReveal === 'function') apiPb.playPbCopyEndReveal();
          }
        }
      }
      dim.style.backgroundColor = 'rgba(0,0,0,' + dimA.toFixed(4) + ')';
      api65.setUnitProgress(u65);
      apiPb.setUnitProgress(uPb);
    };

    const st = ScrollTrigger.create({
      trigger: comboScroll,
      start: 'top top',
      end: 'bottom bottom',
      scrub: NA_SCROLL_SCRUB_LAG_SEC,
      invalidateOnRefresh: true,
      onRefresh: () => {
        syncComboHeight();
      },
      onUpdate: (self) => {
        applyComboProgress(self.progress);
      }
    });
    registered.push(st);

    sec65.classList.add('is-air65-copy-frame-anim');
    secPb.classList.add('is-air65-copy-frame-anim');
        cleanups.push(() => {
      sec65.classList.remove('is-air65-copy-frame-anim');
      secPb.classList.remove('is-air65-copy-frame-anim');
    });

    applyComboProgress(0);
    window.requestAnimationFrame(() => {
      applyComboProgress(st.progress || 0);
    });

    cleanups.push(() => {
      if (typeof apiPb.killCopyTweens === 'function') {
        try {
          apiPb.killCopyTweens();
        } catch (_) {}
      }
      try {
        if (dim.parentNode) {
          dim.parentNode.removeChild(dim);
        }
      } catch (_) {}
      pin65.classList.remove('is-air65-combo-dim-host');
      sec65.classList.remove('is-air65-combo-screen', 'is-air65-combo-screen--base');
      secPb.classList.remove('is-air65-combo-screen', 'is-air65-combo-screen--cover');
      secPb.style.top = '';
      try {
        st.kill();
      } catch (_) {}
      try {
        parent.insertBefore(sec65, comboScroll);
        parent.insertBefore(secPb, comboScroll);
        parent.removeChild(comboScroll);
      } catch (_) {}
    });

    scheduleNexodeAirTemplateScrollTriggerRefresh();
    return true;
  }

  function initWhenNexode65wAir65(root, ctx) {
    const gsap = window.gsap;
    const ScrollTrigger = window.ScrollTrigger;
    const { cleanups, registered, reduced } = ctx;

    root.querySelectorAll('[data-na-air65]').forEach((section) => {
      if (!(section instanceof HTMLElement)) return;
      if (section._naAir65ComboSkip) return;
      const pin = section.querySelector('.ug-nexode-air-template__air65-pin');
      const stage = section.querySelector('.ug-nexode-air-template__air65-stage');
      const copy = section.querySelector('[data-na-air65-copy]');
      const canvas = section.querySelector('[data-na-air65-canvas]');
      const poster = section.querySelector('[data-na-air65-poster]');
      const moVideoEl = section.querySelector('[data-na-air65-mo-video]');
      const copyHeading = copy instanceof HTMLElement ? copy.querySelector('.ug-nexode-air-template__air65-title') : null;
      const copyDesc = copy instanceof HTMLElement ? copy.querySelector('.ug-nexode-air-template__air65-desc') : null;
      const headingHighlights =
        copyHeading instanceof HTMLElement
          ? Array.from(copyHeading.querySelectorAll('b, strong')).filter((el) => el instanceof HTMLElement)
          : [];
      const prefix = section.dataset.framePrefix || '';
      const count = Number.parseInt(section.dataset.frameCount || '0', 10);
      const padW = Number.parseInt(section.dataset.framePad || '3', 10);
      const ext = section.dataset.frameExt || 'webp';
      const copyLineSelector = '.ug-nexode-air-template__air65-title, .ug-nexode-air-template__air65-desc';
      const copyLines =
        copy instanceof HTMLElement
          ? Array.from(copy.querySelectorAll(copyLineSelector)).filter((el) => el instanceof HTMLElement)
          : [];

      const isAir65Mobile =
        typeof window.matchMedia === 'function' && window.matchMedia(MOBILE_MQ).matches;
      const moVideoUrl = (section.dataset.air65MoVideo || '').trim();
      const pbMaskAttr = (section.getAttribute('data-air65-mask-wipe') || '').trim();
      const isPbMaskWipeSection =
        pbMaskAttr === '1' ||
        pbMaskAttr === 'true' ||
        section.dataset.air65MaskWipe === '1' ||
        section.dataset.air65MaskWipe === 'true';
      const pbStandaloneEndCopy =
        !isAir65Mobile &&
        isPbMaskWipeSection &&
        copy instanceof HTMLElement &&
        gsap
          ? naAir65PbEndCopyHelpers(copy, ctx)
          : null;
      let pbStandaloneTailActive = false;
      const stPinWrapEl =
        !isAir65Mobile && isPbMaskWipeSection ? section.querySelector('[data-air65-st-pin]') : null;
      const frameHoldLast =
        !isAir65Mobile &&
        (section.dataset.air65FrameHold === '1' || section.dataset.air65FrameHold === 'true');

      if (!isAir65Mobile && frameHoldLast && gsap) {
        const pbCand = naAir65FindNextMaskWipeSection(section);
        if (pbCand instanceof HTMLElement && naAir65HoldImmediatelyPrecedesSection(section, pbCand)) {
          pbCand._naAir65ComboSkip = true;
          if (naAir65TryInitWpbCombo(section, pbCand, ctx)) {
            return;
          }
          try {
            delete pbCand._naAir65ComboSkip;
          } catch (_) {}
        }
      }

      let air65HoldTriggerRef = null;
      const clamp01 = (n) => Math.max(0, Math.min(1, n));
      let air65TitleGradientShown = false;

      const applyAir65CopyFrameReveal = (frameIndex) => {
        if (!(copyHeading instanceof HTMLElement) || !(copyDesc instanceof HTMLElement) || !gsap) return;
        if (reduced) {
          gsap.set(copyHeading, { autoAlpha: 1, y: 0, filter: 'blur(0px)' });
          gsap.set(copyDesc, { autoAlpha: 1, y: 0, filter: 'blur(0px)' });
          copyHeading.classList.add('is-revealed');
          headingHighlights.forEach((el) => {
            el.style.setProperty('--na-title-reveal', '100%');
          });
          return;
        }
        const descT = clamp01((frameIndex - AIR65_DESC_REVEAL_START_FRAME) / AIR65_DESC_REVEAL_SPAN);
        gsap.set(copyHeading, { autoAlpha: 1, y: 0, filter: 'blur(0px)' });
        gsap.set(copyDesc, {
          autoAlpha: descT,
          y: 12 * (1 - descT),
          filter: 'blur(' + (12 * (1 - descT)).toFixed(2) + 'px)'
        });
        const descFullyShown = descT >= 1 - AIR65_FRAME_EPS;
        if (descFullyShown) {
          copyHeading.classList.add('is-revealed');
          if (!air65TitleGradientShown) {
            air65TitleGradientShown = true;
            headingHighlights.forEach((el) => {
              el.style.setProperty('--na-title-reveal', '0%');
            });
            if (headingHighlights.length) {
              gsap.killTweensOf(headingHighlights);
              gsap.to(headingHighlights, {
                duration: 0.55,
                ease: 'power2.out',
                '--na-title-reveal': '100%'
              });
            }
          }
        } else {
          if (air65TitleGradientShown && headingHighlights.length) {
            gsap.killTweensOf(headingHighlights);
          }
          air65TitleGradientShown = false;
          copyHeading.classList.remove('is-revealed');
          headingHighlights.forEach((el) => {
            el.style.setProperty('--na-title-reveal', '0%');
          });
        }
      };

      const applyAir65TitleHighlightReveal = (opts) => {
        const animate = !(opts && opts.animate === false);
        if (!(copyHeading instanceof HTMLElement) || !headingHighlights.length) return;
        if (reduced || !gsap || !animate) {
          copyHeading.classList.add('is-revealed');
          headingHighlights.forEach((el) => el.style.setProperty('--na-title-reveal', '100%'));
          return;
        }
        copyHeading.classList.add('is-revealed');
        headingHighlights.forEach((el) => el.style.setProperty('--na-title-reveal', '0%'));
        gsap.killTweensOf(headingHighlights);
        gsap.to(headingHighlights, {
          duration: 0.55,
          ease: 'power2.out',
          '--na-title-reveal': '100%'
        });
      };

      const setupAir65CopyEnter = () => {
        if (!gsap) return;
        if (copy instanceof HTMLElement) {
          gsap.set(copy, { autoAlpha: 1, y: 0 });
        }
        if (copyLines.length) {
          gsap.set(copyLines, { autoAlpha: 0, y: 28 });
          const enterTl = gsap.timeline({
            scrollTrigger: {
              trigger: section,
              start: NA_SCROLL_REVEAL_START,
              once: true
            }
          });
          enterTl.to(copyLines, {
            autoAlpha: 1,
            y: 0,
            duration: isAir65Mobile ? 1.12 : 0.92,
            stagger: isAir65Mobile ? 0.28 : 0.22,
            ease: 'power2.out'
          });
          enterTl.add(() => applyAir65TitleHighlightReveal({ animate: true }));
          if (enterTl.scrollTrigger) {
            registered.push(enterTl.scrollTrigger);
          }
        }
      };

      if (isAir65Mobile && moVideoUrl && moVideoEl instanceof HTMLVideoElement) {
        if (!(pin instanceof HTMLElement) || !(stage instanceof HTMLElement)) return;

        moVideoEl.loop = false;
        naPrimeInlineVideoForAutoplay(moVideoEl);
        try {
          moVideoEl.pause();
          moVideoEl.currentTime = 0;
        } catch (_) {}

        // 无 GSAP 时：进视口后 CSS 淡入再 play（与下面 ScrollTrigger 语义对齐）
        const setupMoVideoIoFallback = () => {
          moVideoEl.classList.add('ug-nexode-air-template__air65-mo-video--io-reveal');
          if (typeof IntersectionObserver === 'undefined') {
            moVideoEl.classList.add('is-visible');
            window.setTimeout(() => naTryPlayInlineVideo(moVideoEl), 480);
            return;
          }
          const io = new IntersectionObserver(
            (entries) => {
              entries.forEach((ent) => {
                if (!ent.isIntersecting) return;
                io.disconnect();
                moVideoEl.classList.add('is-visible');
                window.setTimeout(() => naTryPlayInlineVideo(moVideoEl), 500);
              });
            },
            { threshold: 0.14, rootMargin: '0px 0px -6% 0px' }
          );
          io.observe(moVideoEl);
          cleanups.push(() => {
            try {
              io.disconnect();
            } catch (_) {}
          });
        };

        if (gsap && ScrollTrigger) {
          gsap.set(moVideoEl, { autoAlpha: 0 });
          const fadeDur = reduced ? 0 : 0.58;
          const videoEnterTl = gsap.timeline({
            scrollTrigger: {
              trigger: section,
              start: NA_SCROLL_REVEAL_START,
              once: true
            }
          });
          videoEnterTl.to(moVideoEl, {
            autoAlpha: 1,
            duration: fadeDur,
            ease: 'power2.out'
          });
          videoEnterTl.add(() => naTryPlayInlineVideo(moVideoEl));
          if (videoEnterTl.scrollTrigger) {
            registered.push(videoEnterTl.scrollTrigger);
          }
        } else {
          setupMoVideoIoFallback();
        }

        if (!gsap || !ScrollTrigger || reduced) {
          copyLines.forEach((el) => {
            el.style.opacity = '1';
            el.style.visibility = 'visible';
            el.style.transform = 'none';
          });
          if (copy instanceof HTMLElement) {
            copy.style.opacity = '';
            copy.style.visibility = '';
            copy.style.transform = '';
          }
          applyAir65TitleHighlightReveal({ animate: false });
        } else {
          setupAir65CopyEnter();
        }
        return;
      }

      if (
        !(pin instanceof HTMLElement) ||
        !(stage instanceof HTMLElement) ||
        !(canvas instanceof HTMLCanvasElement) ||
        !prefix ||
        !count
      ) {
        return;
      }

      const ctx2d = canvas.getContext('2d');
      if (!ctx2d) return;

      const isAir65MobileFramesOnly = isAir65Mobile && !moVideoUrl;
      const frameLoadCount = isAir65MobileFramesOnly ? 1 : count;
      const highPriorityFrameCount = isAir65Mobile
        ? AIR65_PRELOAD_HIGH_COUNT_MOBILE
        : AIR65_PRELOAD_HIGH_COUNT_DESKTOP;

      const frames = [];
      const imageSequence = { frame: 0 };

      const resolveRenderableFrame = (targetIndex) => {
        const safeIndex = Math.min(count - 1, Math.max(0, targetIndex));
        const direct = frames[safeIndex];
        if (direct && direct.complete && direct.naturalWidth) {
          return direct;
        }
        for (let prev = safeIndex - 1; prev >= 0; prev -= 1) {
          const prevFrame = frames[prev];
          if (prevFrame && prevFrame.complete && prevFrame.naturalWidth) {
            return prevFrame;
          }
        }
        for (let next = safeIndex + 1; next < count; next += 1) {
          const nextFrame = frames[next];
          if (nextFrame && nextFrame.complete && nextFrame.naturalWidth) {
            return nextFrame;
          }
        }
        return null;
      };

      const applyCanvasBufferSize = () => {
        const w = stage.offsetWidth;
        const h = stage.offsetHeight;
        if (w <= 0 || h <= 0) return;
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        const bw = Math.max(1, Math.round(w * dpr));
        const bh = Math.max(1, Math.round(h * dpr));
        if (canvas.width !== bw || canvas.height !== bh) {
          canvas.width = bw;
          canvas.height = bh;
        }
      };

      const renderCanvas = () => {
        const frameIndex = Math.min(count - 1, Math.max(0, Math.round(imageSequence.frame)));
        const frame = resolveRenderableFrame(frameIndex);
        if (!frame) return;
        applyCanvasBufferSize();
        const ctx = ctx2d;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        const scale = Math.max(canvas.width / frame.naturalWidth, canvas.height / frame.naturalHeight);
        const drawWidth = frame.naturalWidth * scale;
        const drawHeight = frame.naturalHeight * scale;
        const drawX = (canvas.width - drawWidth) / 2;
        const drawY = (canvas.height - drawHeight) / 2;
        ctx.drawImage(frame, drawX, drawY, drawWidth, drawHeight);
        if (poster instanceof HTMLElement) {
          poster.classList.add('is-hidden');
        }
      };

      const renderFirstFrame = () => {
        imageSequence.frame = 0;
        renderCanvas();
      };

      const resizeCanvas = () => {
        renderCanvas();
      };

      for (let i = 0; i < frameLoadCount; i += 1) {
        const img = new Image();
        img.decoding = 'async';
        if ('fetchPriority' in img) {
          img.fetchPriority = i < highPriorityFrameCount ? 'high' : 'low';
        }
        if (i === 0) {
          img.onload = function () {
            resizeCanvas();
            renderFirstFrame();
            scheduleNexodeAirTemplateScrollTriggerRefresh();
          };
        } else {
          img.onload = () => {
            const cur = Math.round(imageSequence.frame);
            if (Math.abs(i - cur) <= 1) {
              renderCanvas();
            }
          };
        }
        img.src = buildNexodeAirTemplateFrameUrl(prefix, i + 1, padW, ext);
        frames[i] = img;
      }

      resizeCanvas();
      renderFirstFrame();

      const onAir65WindowResize = () => {
        resizeCanvas();
        renderCanvas();
      };
      window.addEventListener('resize', onAir65WindowResize, { passive: true });
      cleanups.push(() => window.removeEventListener('resize', onAir65WindowResize));

      let ro = null;
      if (typeof ResizeObserver === 'function') {
        ro = new ResizeObserver(() => {
          resizeCanvas();
          renderCanvas();
        });
        ro.observe(stage);
        cleanups.push(() => {
          try {
            ro.disconnect();
          } catch (_) {}
        });
      }

      if (!gsap || !ScrollTrigger || reduced) {
        copyLines.forEach((el) => {
          el.style.opacity = '1';
          el.style.visibility = 'visible';
          el.style.transform = 'none';
        });
        if (copy instanceof HTMLElement) {
          copy.style.opacity = '';
          copy.style.visibility = '';
          copy.style.transform = '';
        }
        renderFirstFrame();
        return;
      }

      if (isAir65MobileFramesOnly) {
        setupAir65CopyEnter();
        return;
      }
      let lastRenderedFrameIndex = -1;
      if (pbStandaloneEndCopy && isPbMaskWipeSection && !frameHoldLast && !isAir65Mobile) {
        pbStandaloneEndCopy.applyHidden();
      }

      const getAir65ScrollBase = () => {
        const vh = Math.max(
          typeof window.innerHeight === 'number' ? window.innerHeight : 0,
          pin.offsetHeight || 0,
          stage.offsetHeight || 0,
          800
        );
        const frameMult = isAir65Mobile ? 1.65 : 1.65;
        const countFactor = Math.min(1.55, Math.max(1, count / 100));
        const framePxFull = Math.round(vh * frameMult * countFactor);
        return { vh, framePxFull };
      };

      const applyAir65CopyAndFrame = (progress, frameIndexMaxInclusive) => {
        const safeProgress = Math.max(0, Math.min(1, progress));
        const frameT = Math.max(0, Math.min(1, safeProgress));
        let nextFrameIndex;
        if (frameT <= AIR65_FRAME_EPS) {
          nextFrameIndex = 0;
        } else if (frameT >= 1 - AIR65_FRAME_EPS) {
          nextFrameIndex = frameIndexMaxInclusive;
        } else {
          nextFrameIndex = Math.min(
            frameIndexMaxInclusive,
            Math.max(0, Math.round(frameIndexMaxInclusive * frameT))
          );
        }
        if (nextFrameIndex !== lastRenderedFrameIndex) {
          lastRenderedFrameIndex = nextFrameIndex;
          imageSequence.frame = nextFrameIndex;
          renderCanvas();
        }
        if (!isAir65Mobile && !isPbMaskWipeSection) {
          applyAir65CopyFrameReveal(nextFrameIndex);
        }
      };

      const getAir65ScrollMetrics = () => {
        const { vh, framePxFull } = getAir65ScrollBase();
        let hold65OnlyTotalPx;
        if (frameHoldLast) {
          const holdPx = Math.round(vh * AIR65_HOLD_LAST_VH);
          hold65OnlyTotalPx = Math.max(framePxFull + holdPx, Math.round(vh * 1.25));
        } else {
          hold65OnlyTotalPx = Math.max(framePxFull, Math.round(vh * 1.25));
        }
        const pbCopyTailPx =
          !isAir65Mobile && isPbMaskWipeSection && !frameHoldLast ? Math.round(vh * AIR65_PB_COPY_TAIL_VH) : 0;
        const totalPx = hold65OnlyTotalPx + pbCopyTailPx;
        return { totalPx, framePxFull, hold65OnlyTotalPx, pbCopyTailPx };
      };

      const updateAir65State = (progress) => {
        applyAir65CopyAndFrame(progress, count - 1);
      };

      const updateAir65StateFromTriggerProgress = (triggerProgress) => {
        const tp = clamp01(triggerProgress);
        let frameProgress = tp;

        if (!isAir65Mobile && isPbMaskWipeSection && !frameHoldLast && pbStandaloneEndCopy) {
          const { totalPx, hold65OnlyTotalPx, pbCopyTailPx } = getAir65ScrollMetrics();
          if (pbCopyTailPx > 0) {
            const denom = Math.max(totalPx, 1e-9);
            const framePhaseEnd = hold65OnlyTotalPx / denom;
            if (tp < framePhaseEnd - 1e-12) {
              frameProgress = framePhaseEnd <= 1e-9 ? 1 : tp / framePhaseEnd;
              if (pbStandaloneTailActive) {
                pbStandaloneTailActive = false;
                pbStandaloneEndCopy.applyHidden();
                pbStandaloneEndCopy.killCopyTweens();
              }
            } else {
              frameProgress = 1;
              if (!pbStandaloneTailActive) {
                pbStandaloneTailActive = true;
                pbStandaloneEndCopy.playEndReveal();
              }
            }
            updateAir65State(frameProgress);
            return;
          }
        }

        if (frameHoldLast) {
          const { totalPx, framePxFull, hold65OnlyTotalPx } = getAir65ScrollMetrics();
          const effectiveTotal = hold65OnlyTotalPx !== undefined ? hold65OnlyTotalPx : totalPx;
          if (effectiveTotal > 0 && framePxFull > 0) {
            const phaseEnd = Math.min(1, framePxFull / effectiveTotal);
            if (phaseEnd <= 1e-9) {
              frameProgress = 1;
            } else if (tp >= phaseEnd - 1e-12) {
              frameProgress = 1;
            } else {
              frameProgress = tp / phaseEnd;
            }
          }
        }
        updateAir65State(frameProgress);
      };

      if (!isAir65Mobile) {
        section.classList.add('is-air65-copy-frame-anim');
        cleanups.push(() => section.classList.remove('is-air65-copy-frame-anim'));
      }

      const pinScrollTarget = stPinWrapEl instanceof HTMLElement ? stPinWrapEl : pin;

      const air65StBase = {
          trigger: section,
          start: 'top top',
          end: () => '+=' + getAir65ScrollMetrics().totalPx,
        pin: pinScrollTarget,
          pinSpacing: true,
          scrub: NA_SCROLL_SCRUB_LAG_SEC,
          anticipatePin: 0,
          invalidateOnRefresh: true,
          onUpdate: (self) => {
          updateAir65StateFromTriggerProgress(self.progress);
        },
        onRefreshInit: (self) => {
          if (self) {
            air65HoldTriggerRef = self;
          }
          resizeCanvas();
        },
        onRefresh: () => {
          renderCanvas();
          window.requestAnimationFrame(() => {
            if (!air65HoldTriggerRef || typeof air65HoldTriggerRef.progress !== 'number') return;
            updateAir65StateFromTriggerProgress(air65HoldTriggerRef.progress);
          });
        }
      };
      if (stPinWrapEl instanceof HTMLElement) {
        air65StBase.pinType = 'fixed';
      }
      const air65Trigger = ScrollTrigger.create(air65StBase);

      air65HoldTriggerRef = air65Trigger;

      updateAir65StateFromTriggerProgress(air65Trigger ? air65Trigger.progress || 0 : 0);

        window.requestAnimationFrame(() => {
        updateAir65StateFromTriggerProgress(air65Trigger ? air65Trigger.progress || 0 : 0);
        });
        if (air65Trigger) {
          registered.push(air65Trigger);
        }
      if (pbStandaloneEndCopy) {
        cleanups.push(() => {
          try {
            pbStandaloneEndCopy.killCopyTweens();
          } catch (_) {}
        });
      }
    });
  }

  function initNexodeAirTemplateColorCompat(root, ctx) {
    const { cleanups, registered, reduced } = ctx;
    const gsap = window.gsap;
    const ScrollTrigger = window.ScrollTrigger;
    const colorSwitchTokenBySection = new WeakMap();
    const colorAnimAbortBySection = new WeakMap();

    root.querySelectorAll('[data-na-colors]').forEach((section) => {
      if (!(section instanceof HTMLElement)) return;
      const pairs = section.querySelectorAll('[data-na-colors-pair]');
      const tabs = section.querySelectorAll('[data-na-colors-tab]');
      const tabsContainer = section.querySelector('.ug-nexode-air-template__colors-tabs');
      const indicator = section.querySelector('[data-na-colors-indicator]');
      const prevBtn = section.querySelector('[data-na-colors-prev]');
      const nextBtn = section.querySelector('[data-na-colors-next]');
      const eyebrow = section.querySelector('[data-na-colors-eyebrow]');
      const tabsOuter = section.querySelector('[data-na-colors-tabs-outer]');

      if (!tabs.length || !pairs.length) {
        return;
      }
      if (pairs.length !== tabs.length) {
        // 数量不一致时跳过初始化；可通过 DOM 上 data-na-colors-init-skip="count-mismatch" 排查
        section.setAttribute('data-na-colors-init-skip', 'count-mismatch');
        return;
      }
      section.removeAttribute('data-na-colors-init-skip');

      const getIsMobile = () =>
        typeof window.matchMedia === 'function' && window.matchMedia(MOBILE_MQ).matches;

      const resolveTabActiveBg = (btn) => {
        if (!(btn instanceof HTMLElement)) return '#858694';
        return (btn.dataset.activeBg || '').trim() || '#858694';
      };

      const resolveTabActiveFg = (btn) => {
        if (!(btn instanceof HTMLElement)) return '#ffffff';
        const fg = (btn.dataset.activeColor || '').trim();
        if (fg) return fg;
        return nexodeAirTabLabelColorForBg(resolveTabActiveBg(btn));
      };

      const applyTabVisual = (activeBtn) => {
        tabs.forEach((t) => {
          if (!(t instanceof HTMLElement)) return;
          const active = t === activeBtn;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
          const bg = resolveTabActiveBg(t);
          if (active) {
            t.style.backgroundColor = '';
            t.style.color = resolveTabActiveFg(t);
          } else {
            t.style.backgroundColor = '';
            t.style.color = '';
          }
        });
        if (indicator instanceof HTMLElement && activeBtn instanceof HTMLElement) {
          indicator.style.backgroundColor = resolveTabActiveBg(activeBtn);
        }
      };

      const syncIndicator = (activeBtn, animate) => {
        if (!(tabsContainer instanceof HTMLElement) || !(indicator instanceof HTMLElement) || !(activeBtn instanceof HTMLElement)) {
          return;
        }
        const p = tabsContainer.getBoundingClientRect();
        const b = activeBtn.getBoundingClientRect();
        const left = b.left - p.left + tabsContainer.scrollLeft;
        const rawTop = b.top - p.top + tabsContainer.scrollTop;
        const top = rawTop - 1;
        const w = b.width;
        const h = b.height;
        if (animate && gsap && !reduced) {
          gsap.to(indicator, {
            left: left,
            top: top,
            width: w,
            height: h,
            duration: 0.4,
            ease: 'power3.out'
          });
        } else if (gsap) {
          gsap.set(indicator, { left: left, top: top, width: w, height: h });
        } else {
          indicator.style.left = left + 'px';
          indicator.style.top = top + 'px';
          indicator.style.width = w + 'px';
          indicator.style.height = h + 'px';
        }
      };

      const scheduleIndicatorSync = () => {
        const cur = section.querySelector('[data-na-colors-tab].is-active') || tabs[0];
        if (cur instanceof HTMLElement) {
          syncIndicator(cur, false);
        }
      };

      const getActiveTabIndex = () => {
        const cur = section.querySelector('[data-na-colors-tab].is-active');
        const idx = cur ? Array.prototype.indexOf.call(tabs, cur) : 0;
        return Math.max(0, Math.min(tabs.length - 1, idx));
      };

      const updateNavButtons = () => {
        const showNav = tabs.length > 1;
        const activeIdx = getActiveTabIndex();
        const showPrev = showNav && activeIdx > 0;
        const showNext = showNav && activeIdx < tabs.length - 1;
        if (prevBtn instanceof HTMLButtonElement) {
          prevBtn.hidden = !showPrev;
        }
        if (nextBtn instanceof HTMLButtonElement) {
          nextBtn.hidden = !showNext;
        }
      };

      const syncColorsTabsUi = (activeBtn, animate) => {
        updateNavButtons();
        const targetBtn =
          activeBtn instanceof HTMLElement
            ? activeBtn
            : section.querySelector('[data-na-colors-tab].is-active') || tabs[0];
        window.requestAnimationFrame(() => {
          if (targetBtn instanceof HTMLElement) {
            syncIndicator(targetBtn, !!animate);
          }
        });
      };

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          syncColorsTabsUi(activeTab instanceof HTMLElement ? activeTab : tabs[0], false);
        });
      });

      const activeTab = section.querySelector('[data-na-colors-tab].is-active') || tabs[0];
      if (activeTab instanceof HTMLElement) {
        applyTabVisual(activeTab);
      }
      syncColorsTabsUi(activeTab instanceof HTMLElement ? activeTab : tabs[0], false);

      const onTabsScroll = () => {
        const cur = section.querySelector('[data-na-colors-tab].is-active');
        if (cur instanceof HTMLElement) {
          syncIndicator(cur, false);
        }
      };
      if (tabsContainer instanceof HTMLElement) {
        tabsContainer.addEventListener('scroll', onTabsScroll, { passive: true });
        cleanups.push(() => tabsContainer.removeEventListener('scroll', onTabsScroll));
      }

      let tabRo = null;
      if (typeof ResizeObserver !== 'undefined' && tabsContainer instanceof HTMLElement) {
        tabRo = new ResizeObserver(() => {
          const cur = section.querySelector('[data-na-colors-tab].is-active');
          if (cur instanceof HTMLElement) {
            syncIndicator(cur, false);
          }
        });
        tabRo.observe(tabsContainer);
        cleanups.push(() => {
          try {
            tabRo.disconnect();
          } catch (_) {}
        });
      }

      const onWinResize = () => {
        const cur = section.querySelector('[data-na-colors-tab].is-active');
        syncColorsTabsUi(cur instanceof HTMLElement ? cur : tabs[0], false);
        if (!colorsIntroPlayed && getIsMobile() !== lastIntroIsMobile) {
          resetIntroMediaState();
        }
      };
      window.addEventListener('resize', onWinResize, { passive: true });
      cleanups.push(() => window.removeEventListener('resize', onWinResize));

      const getActiveSlideElements = () => {
        const cur = section.querySelector('[data-na-colors-tab].is-active');
        const idx = cur ? Array.prototype.indexOf.call(tabs, cur) : 0;
        const safe = Math.max(0, Math.min(tabs.length - 1, idx));
        const pair = pairs[safe];
        if (!(pair instanceof HTMLElement)) {
          return { left: null, right: null };
        }
        const left = pair.querySelector('.ug-nexode-air-template__colors-img-crop--left');
        const right = pair.querySelector('.ug-nexode-air-template__colors-right-tile');
        return { left, right };
      };

      const setStaticFinal = () => {
        if (eyebrow instanceof HTMLElement) {
          eyebrow.style.opacity = '1';
          eyebrow.style.transform = 'none';
          eyebrow.classList.add('is-revealed');
        }
        pairs.forEach((el) => {
          if (el instanceof HTMLElement) {
            el.style.opacity = '';
            el.style.transform = '';
            el.style.removeProperty('z-index');
          }
        });
        if (tabsOuter instanceof HTMLElement) {
          tabsOuter.style.opacity = '1';
          tabsOuter.style.transform = 'none';
        }
        scheduleIndicatorSync();
      };

      const runTabSwitchAnimation = (btn) => {
        let prevActive = section.querySelector('[data-na-colors-tab].is-active');
        if (!(prevActive instanceof HTMLElement)) {
          prevActive = tabs[0];
        }
        const fromIdx = Array.prototype.indexOf.call(tabs, prevActive);
        const toIdx = Array.prototype.indexOf.call(tabs, btn);
        if (fromIdx < 0 || toIdx < 0 || fromIdx === toIdx) {
          return;
        }

        const outPair = pairs[fromIdx];
        const inPair = pairs[toIdx];
        if (!(outPair instanceof HTMLElement) || !(inPair instanceof HTMLElement)) {
          return;
        }

        const outLeft = outPair.querySelector('.ug-nexode-air-template__colors-img-crop--left');
        const outRight = outPair.querySelector('.ug-nexode-air-template__colors-right-tile');
        const inLeft = inPair.querySelector('.ug-nexode-air-template__colors-img-crop--left');
        const inRight = inPair.querySelector('.ug-nexode-air-template__colors-right-tile');
        if (
          !(outLeft instanceof HTMLElement) ||
          !(outRight instanceof HTMLElement) ||
          !(inLeft instanceof HTMLElement) ||
          !(inRight instanceof HTMLElement)
        ) {
          return;
        }

        applyTabVisual(btn);
        syncColorsTabsUi(btn, true);

        if (reduced || !gsap) {
          outPair.classList.remove('is-active', 'current');
          inPair.classList.add('is-active', 'current');
          outPair.setAttribute('aria-hidden', 'true');
          inPair.setAttribute('aria-hidden', 'false');
          return;
        }

        const prevAbort = colorAnimAbortBySection.get(section);
        if (typeof prevAbort === 'function') {
          try {
            prevAbort();
          } catch (_) {}
        }

        const switchToken = (colorSwitchTokenBySection.get(section) || 0) + 1;
        colorSwitchTokenBySection.set(section, switchToken);

        gsap.killTweensOf([outPair, inPair, outLeft, outRight, inLeft, inRight]);

        const SWITCH_MS = 800;
        const switchSec = SWITCH_MS / 1000;

        pairs.forEach((el) => {
          if (el instanceof HTMLElement) el.style.removeProperty('z-index');
        });
        outPair.style.zIndex = '3';
        inPair.style.zIndex = '2';
        outPair.classList.remove('is-active');
        outPair.classList.add('current');
        inPair.classList.add('is-active', 'current');
        inPair.setAttribute('aria-hidden', 'false');

        gsap.set(inPair, { autoAlpha: 1 });
        gsap.set(outPair, { autoAlpha: 1 });
        gsap.set(inLeft, { autoAlpha: 1 });
        gsap.set(inRight, { autoAlpha: 1 });
        gsap.set(outRight, { autoAlpha: 1 });

        const outLeftRect = outLeft.getBoundingClientRect();
        const targetSize = 0;
        const targetVisibleWidth = Math.min(targetSize, outLeftRect.width);
        const targetVisibleHeight = Math.min(targetSize, outLeftRect.height);
        const maxInsetX = Math.max(0, (outLeftRect.width - targetVisibleWidth) / 2);
        const maxInsetY = Math.max(0, (outLeftRect.height - targetVisibleHeight) / 2);
        const clipState = { progress: 0 };
        const OUT_LEFT_FADE_START_W = 80;

        const applyOutLeftClip = (progress) => {
          const safe = Math.max(0, Math.min(1, progress));
          const insetX = maxInsetX * safe;
          const insetY = maxInsetY * safe;
          const clipValue =
            'inset(' +
            insetY.toFixed(3) +
            'px ' +
            insetX.toFixed(3) +
            'px ' +
            insetY.toFixed(3) +
            'px ' +
            insetX.toFixed(3) +
            'px round 30px)';
          outLeft.style.clipPath = clipValue;
          outLeft.style.webkitClipPath = clipValue;
          const visibleW = Math.max(0, outLeftRect.width - 2 * insetX);
          const fadeOp =
            visibleW >= OUT_LEFT_FADE_START_W ? 1 : Math.max(0, visibleW / OUT_LEFT_FADE_START_W);
          gsap.set(outLeft, { opacity: fadeOp });
        };

        applyOutLeftClip(0);

        const finalizePairClasses = () => {
          outPair.classList.remove('is-active', 'current');
          inPair.classList.add('is-active', 'current');
          outPair.setAttribute('aria-hidden', 'true');
          inPair.setAttribute('aria-hidden', 'false');
        };

        const clearPairAnimStyles = () => {
          try {
            gsap.set([outPair, inPair, outLeft, outRight, inLeft, inRight], { clearProps: 'opacity,visibility,transform' });
          } catch (_) {}
          outLeft.style.clipPath = '';
          outLeft.style.webkitClipPath = '';
          outPair.style.removeProperty('z-index');
          inPair.style.removeProperty('z-index');
        };

        const tl = gsap.timeline({
          onComplete: () => {
            if (colorSwitchTokenBySection.get(section) !== switchToken) {
              return;
            }
            colorAnimAbortBySection.delete(section);
            finalizePairClasses();
            clearPairAnimStyles();
          }
        });

        tl.to(
          clipState,
          {
            duration: switchSec,
            progress: 1,
            ease: 'power2.inOut',
            onUpdate: () => {
              applyOutLeftClip(clipState.progress);
            }
          },
          0
        );
        tl.fromTo(
          inRight,
          { autoAlpha: 0 },
          {
            autoAlpha: 1,
            duration: switchSec,
            ease: 'power2.out'
          },
          0
        );
        tl.to(
          outRight,
          {
            autoAlpha: 0,
            duration: switchSec,
            ease: 'power2.inOut'
          },
          0
        );

        colorAnimAbortBySection.set(section, () => {
          try {
            tl.kill();
          } catch (_) {}
          try {
            gsap.killTweensOf([outPair, inPair, outLeft, outRight, inLeft, inRight, clipState]);
          } catch (_) {}
          finalizePairClasses();
          clearPairAnimStyles();
          colorAnimAbortBySection.delete(section);
        });
      };

      const onTabClick = (e) => {
        const btn = e.currentTarget;
        if (!(btn instanceof HTMLElement)) return;
        if (btn.classList.contains('is-active')) return;
        runTabSwitchAnimation(btn);
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', onTabClick);
        cleanups.push(() => tab.removeEventListener('click', onTabClick));
      });

      if (prevBtn instanceof HTMLButtonElement) {
        const onPrevClick = () => {
          const activeIdx = getActiveTabIndex();
          const prevIdx = Math.max(0, activeIdx - 1);
          const prevTab = tabs[prevIdx];
          if (!(prevTab instanceof HTMLElement)) return;
          if (!prevTab.classList.contains('is-active')) {
            runTabSwitchAnimation(prevTab);
          }
          if (typeof prevTab.scrollIntoView === 'function') {
            prevTab.scrollIntoView({
              behavior: reduced || getIsMobile() ? 'auto' : 'smooth',
              inline: 'center',
              block: 'nearest'
            });
          }
        };
        prevBtn.addEventListener('click', onPrevClick);
        cleanups.push(() => prevBtn.removeEventListener('click', onPrevClick));
      }

      if (nextBtn instanceof HTMLButtonElement) {
        const onNextClick = () => {
          const activeIdx = getActiveTabIndex();
          const nextIdx = Math.min(tabs.length - 1, activeIdx + 1);
          const nextTab = tabs[nextIdx];
          if (!(nextTab instanceof HTMLElement)) return;
          if (!nextTab.classList.contains('is-active')) {
            runTabSwitchAnimation(nextTab);
          }
          if (typeof nextTab.scrollIntoView === 'function') {
            nextTab.scrollIntoView({
              behavior: reduced || getIsMobile() ? 'auto' : 'smooth',
              inline: 'center',
              block: 'nearest'
            });
          }
        };
        nextBtn.addEventListener('click', onNextClick);
        cleanups.push(() => nextBtn.removeEventListener('click', onNextClick));
      }

      if (reduced || !gsap || !ScrollTrigger) {
        setStaticFinal();
        return;
      }

      const pairEls = getActiveSlideElements();
      const left = pairEls.left;
      const right = pairEls.right;
      const hasPairMedia = left instanceof HTMLElement && right instanceof HTMLElement;
      let colorsIntroPlayed = false;
      let lastIntroIsMobile = getIsMobile();

      const resetIntroMediaState = () => {
        if (!hasPairMedia || !gsap || colorsIntroPlayed) return;
        const nowMobile = getIsMobile();
        lastIntroIsMobile = nowMobile;
        gsap.set([left, right], { clearProps: 'x,y' });
        if (nowMobile) {
          gsap.set(left, { y: -36, autoAlpha: 0 });
          gsap.set(right, { y: 36, autoAlpha: 0 });
        } else {
          gsap.set(left, { x: -72, autoAlpha: 0 });
          gsap.set(right, { x: 72, autoAlpha: 0 });
        }
      };

      resetIntroMediaState();

      if (tabsOuter) {
        gsap.set(tabsOuter, { autoAlpha: 0, y: 14 });
      }

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: NA_SCROLL_REVEAL_START,
          toggleActions: 'play none none none',
          once: true,
          onEnter: () => {
            colorsIntroPlayed = true;
          }
        }
      });

      if (hasPairMedia) {
        if (getIsMobile()) {
          tl.to([left, right], {
              y: 0,
              autoAlpha: 1,
              duration: 0.65,
              stagger: 0.1,
              ease: 'power3.out'
          });
        } else {
          tl.to([left, right], {
              x: 0,
              autoAlpha: 1,
              duration: 0.7,
              stagger: 0.08,
              ease: 'power3.out'
          });
        }
      }

      if (tabsOuter) {
        tl.to(tabsOuter, { autoAlpha: 1, y: 0, duration: 0.5, ease: 'power2.out' }, '-=0.15');
      }

      if (tl.scrollTrigger) {
        registered.push(tl.scrollTrigger);
      }
    });
  }

  function initNexodeAirWhyAir(root, ctx) {
    const { cleanups, reduced } = ctx;
    const gsap = window.gsap;
    const ScrollTrigger = window.ScrollTrigger;
    const isMobile =
      typeof window.matchMedia === 'function' && window.matchMedia(MOBILE_MQ).matches;

    root.querySelectorAll('[data-na-why-air]').forEach((section) => {
      if (!(section instanceof HTMLElement)) return;

      const orderedItems = Array.from(section.querySelectorAll('[data-na-why-air-item]'))
        .filter((el) => el instanceof HTMLElement)
        .sort((a, b) => {
          const ao = Number(a.getAttribute('data-na-why-air-order') || 0);
          const bo = Number(b.getAttribute('data-na-why-air-order') || 0);
          return ao - bo;
        });

      const applyVisibleCount = (count) => {
        orderedItems.forEach((el, idx) => {
          el.classList.toggle('is-visible', idx < count);
        });
      };

      if (!orderedItems.length) return;

      if (reduced || !gsap || !ScrollTrigger || isMobile) {
        applyVisibleCount(orderedItems.length);
      } else {
        applyVisibleCount(0);
        const st = ScrollTrigger.create({
          trigger: section,
          start: 'top 60%',
          end: 'center center',
          scrub: NA_SCROLL_SCRUB_LAG_SEC,
          onUpdate: (self) => {
            const progress = Number(self != null && typeof self.progress === 'number' ? self.progress : 0);
            const n = orderedItems.length;
            const count = Math.min(n, Math.ceil(progress * n));
            applyVisibleCount(count);
          },
          onLeaveBack: () => applyVisibleCount(0)
        });
        cleanups.push(() => {
          try {
            st.kill();
          } catch (_) {}
        });
      }

      const switchCard = section.querySelector('[data-na-why-air-switch]');
      if (!(switchCard instanceof HTMLElement)) return;

      const imgs = Array.from(switchCard.querySelectorAll('[data-na-why-air-switch-img]')).filter(
        (el) => el instanceof HTMLElement
      );
      const dots = Array.from(switchCard.querySelectorAll('[data-na-why-air-switch-dot]')).filter(
        (el) => el instanceof HTMLButtonElement
      );
      if (!imgs.length) return;

      let active = 0;
      let rafId = 0;
      let slideStartedAt = 0;
      const intervalMs = Math.max(1200, Number(switchCard.getAttribute('data-na-why-air-switch-interval') || 2800));

      const syncDotProgress = (p) => {
        const clamped = Math.max(0, Math.min(1, p));
        dots.forEach((dot, i) => {
          dot.style.setProperty('--na-fill', i === active ? String(clamped) : '0');
        });
      };

      const setActive = (idx) => {
        active = ((idx % imgs.length) + imgs.length) % imgs.length;
        imgs.forEach((el, i) => el.classList.toggle('is-active', i === active));
        dots.forEach((el, i) => el.classList.toggle('is-active', i === active));
        syncDotProgress(0);
      };

      const stopAuto = () => {
        if (rafId) {
          window.cancelAnimationFrame(rafId);
          rafId = 0;
        }
      };

      const tick = (now) => {
        rafId = window.requestAnimationFrame(tick);
        let elapsed = now - slideStartedAt;
        if (elapsed >= intervalMs) {
          slideStartedAt = now;
          setActive(active + 1);
          elapsed = 0;
        }
        syncDotProgress(elapsed / intervalMs);
      };

      const startAuto = () => {
        stopAuto();
        if (imgs.length < 2 || reduced) return;
        slideStartedAt = performance.now();
        rafId = window.requestAnimationFrame(tick);
      };

      dots.forEach((dot, idx) => {
        const onClick = (e) => {
          e.preventDefault();
          setActive(idx);
          startAuto();
        };
        dot.addEventListener('click', onClick);
        cleanups.push(() => dot.removeEventListener('click', onClick));
      });

      const onEnter = () => {
        if (imgs.length < 2) return;
        setActive(active + 1);
        stopAuto();
      };
      const onLeave = () => startAuto();
      switchCard.addEventListener('mouseenter', onEnter);
      switchCard.addEventListener('mouseleave', onLeave);
      cleanups.push(() => {
        switchCard.removeEventListener('mouseenter', onEnter);
        switchCard.removeEventListener('mouseleave', onLeave);
      });

      setActive(0);
      startAuto();
      cleanups.push(() => stopAuto());
    });
  }

  function initNexodeAirEventScheduleModal(root, ctx) {
    const { cleanups } = ctx;

    root.querySelectorAll('[data-na-event-schedule]').forEach((wrap) => {
      if (!(wrap instanceof HTMLElement)) return;

      const btn = wrap.querySelector('[data-na-es-detail-open]');
      const modal = wrap.querySelector('[data-na-es-modal]');
      const sOoh = wrap.querySelector('[data-na-es-slides-ooh]');
      const sPopup = wrap.querySelector('[data-na-es-slides-popup]');
      const backdrop =
        modal instanceof HTMLElement ? modal.querySelector('[data-na-es-modal-backdrop]') : null;
      const closeEls = modal ? Array.from(modal.querySelectorAll('[data-na-es-modal-close]')) : [];

      if (!(btn instanceof HTMLElement) || !(modal instanceof HTMLElement) || !(sOoh instanceof HTMLScriptElement)) {
        return;
      }

      const parseSlides = (el) => {
        const raw = (el.textContent || '').trim();
        if (!raw) return [];
        return raw
          .split('|')
          .map((u) => u.trim())
          .filter(Boolean);
      };

      const slidesOoh = parseSlides(sOoh);
      const slidesPopup = sPopup instanceof HTMLScriptElement ? parseSlides(sPopup) : [];

      /** @type {Array<() => void>} */
      const resetFns = [];

      const bindCarousel = (key, urls) => {
        const visual = modal.querySelector(`[data-na-es-carousel-visual="${key}"]`);
        const layers =
          visual instanceof HTMLElement
            ? Array.from(visual.querySelectorAll('[data-na-es-carousel-layer]')).filter((el) => el instanceof HTMLImageElement)
            : [];
        const ctr = modal.querySelector(`[data-na-es-carousel-counter="${key}"]`);
        const prev = modal.querySelector(`[data-na-es-carousel-prev="${key}"]`);
        const next = modal.querySelector(`[data-na-es-carousel-next="${key}"]`);
        if (layers.length < 2 || !(ctr instanceof HTMLElement)) return;

        const [layerA, layerB] = /** @type {[HTMLImageElement, HTMLImageElement]} */ ([layers[0], layers[1]]);

        let idx = 0;
        const n = urls.length;
        let shownLayer = 0;
        let fading = false;

        const setNavDisabled = (dis) => {
          if (prev instanceof HTMLButtonElement) prev.disabled = dis;
          if (next instanceof HTMLButtonElement) next.disabled = dis;
        };

        const apply = () => {
          if (n === 0) {
            layerA.removeAttribute('src');
            layerB.removeAttribute('src');
            layerA.alt = '';
            layerB.alt = '';
            layerA.classList.add('is-visible');
            layerB.classList.remove('is-visible');
            ctr.textContent = '0/0';
            shownLayer = 0;
          } else {
            const u = urls[idx];
            layerA.src = u;
            layerB.src = u;
            layerA.classList.add('is-visible');
            layerB.classList.remove('is-visible');
            shownLayer = 0;
            layerA.alt = '';
            layerB.alt = '';
            ctr.textContent = `${idx + 1}/${n}`;
          }
          setNavDisabled(n <= 1);
        };

        const reset = () => {
          fading = false;
          idx = 0;
          apply();
        };
        resetFns.push(reset);
        apply();

        const fadeToIndex = (nextIdx) => {
          if (n <= 1 || fading || nextIdx === idx) return;
          fading = true;
          setNavDisabled(true);

          const hideEl = shownLayer === 0 ? layerA : layerB;
          const revealEl = shownLayer === 0 ? layerB : layerA;
          const nextUrl = urls[nextIdx];

          const finish = () => {
            revealEl.classList.add('is-visible');
            hideEl.classList.remove('is-visible');
            shownLayer = shownLayer === 0 ? 1 : 0;
            idx = nextIdx;
            ctr.textContent = `${idx + 1}/${n}`;

            let unlocked = false;
            const unlock = () => {
              if (unlocked) return;
              unlocked = true;
              fading = false;
              setNavDisabled(n <= 1);
            };
            const onEnd = (e) => {
              if (!(e instanceof TransitionEvent) || e.target !== revealEl || e.propertyName !== 'opacity') return;
              revealEl.removeEventListener('transitionend', onEnd);
              window.clearTimeout(fallbackId);
              unlock();
            };
            revealEl.addEventListener('transitionend', onEnd);
            const fallbackId = window.setTimeout(() => {
              revealEl.removeEventListener('transitionend', onEnd);
              unlock();
            }, 520);
          };

          const tryFinish = () => {
            if (typeof requestAnimationFrame === 'function') {
              requestAnimationFrame(() => {
                requestAnimationFrame(finish);
              });
            } else {
              setTimeout(finish, 16);
            }
          };

          revealEl.src = nextUrl;
          revealEl.alt = '';

          const onDecodeOrLoad = () => {
            tryFinish();
          };

          if (typeof revealEl.decode === 'function') {
            revealEl
              .decode()
              .then(onDecodeOrLoad)
              .catch(onDecodeOrLoad);
          } else if (revealEl.complete) {
            tryFinish();
          } else {
            revealEl.addEventListener('load', onDecodeOrLoad, { once: true });
            revealEl.addEventListener('error', onDecodeOrLoad, { once: true });
          }
        };

        const step = (d) => {
          if (n <= 1 || fading) return;
          const nextIdx = (idx + d + n) % n;
          fadeToIndex(nextIdx);
        };

        if (prev instanceof HTMLButtonElement) {
          const onPrev = () => step(-1);
          prev.addEventListener('click', onPrev);
          cleanups.push(() => prev.removeEventListener('click', onPrev));
        }
        if (next instanceof HTMLButtonElement) {
          const onNext = () => step(1);
          next.addEventListener('click', onNext);
          cleanups.push(() => next.removeEventListener('click', onNext));
        }
      };

      bindCarousel('ooh', slidesOoh);
      bindCarousel('popup', slidesPopup);

      let bodyOverflow = '';

      const closeModal = () => {
        modal.setAttribute('hidden', '');
        modal.setAttribute('aria-hidden', 'true');
        try {
          document.body.style.overflow = bodyOverflow;
        } catch (_) {}
      };

      const openModal = () => {
        resetFns.forEach((fn) => {
          try {
            fn();
          } catch (_) {}
        });
        modal.removeAttribute('hidden');
        modal.setAttribute('aria-hidden', 'false');
        try {
          bodyOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
        } catch (_) {}
        const firstClose = modal.querySelector('[data-na-es-modal-close]');
        if (firstClose instanceof HTMLElement) {
          try {
            firstClose.focus();
          } catch (_) {}
        }
      };

      const onOpen = (e) => {
        e.preventDefault();
        openModal();
      };
      btn.addEventListener('click', onOpen);
      cleanups.push(() => btn.removeEventListener('click', onOpen));

      closeEls.forEach((el) => {
        if (!(el instanceof HTMLElement)) return;
        const onClose = (e) => {
          e.preventDefault();
          closeModal();
        };
        el.addEventListener('click', onClose);
        cleanups.push(() => el.removeEventListener('click', onClose));
      });

      if (backdrop instanceof HTMLElement) {
        const onBd = () => closeModal();
        backdrop.addEventListener('click', onBd);
        cleanups.push(() => backdrop.removeEventListener('click', onBd));
      }

      const onEsc = (e) => {
        if (!(e instanceof KeyboardEvent) || e.key !== 'Escape') return;
        if (modal.hasAttribute('hidden')) return;
        closeModal();
      };
      document.addEventListener('keydown', onEsc);
      cleanups.push(() => document.removeEventListener('keydown', onEsc));
    });
  }

  function initNexodeAirTvcInlineVideo(root, ctx) {
    const { cleanups } = ctx;
    root.querySelectorAll('[data-na-tvc] video.ug-nexode-air-template__tvc-video').forEach((el) => {
      if (!(el instanceof HTMLVideoElement)) return;
      const stop = naObserveAndRetryVideoPlay(el);
      cleanups.push(stop);
    });
  }

  function initNexodeAirTvcModal(root, ctx) {
    const { cleanups } = ctx;
    root.querySelectorAll('[data-na-tvc]').forEach((section) => {
      if (!(section instanceof HTMLElement)) return;

      const trigger = section.querySelector('.js-na-tvc-video-trigger');
      const modal = section.querySelector('[data-na-tvc-modal]');
      const iframe = section.querySelector('[data-na-tvc-iframe]');
      if (!(trigger instanceof HTMLButtonElement) || !(modal instanceof HTMLElement) || !(iframe instanceof HTMLIFrameElement)) {
        return;
      }

      const closeBtns = Array.from(section.querySelectorAll('[data-na-tvc-modal-close]')).filter(
        (el) => el instanceof HTMLElement
      );

      const withAutoplay = (rawUrl) => {
        const url = String(rawUrl || '').trim();
        if (!url) return '';
        try {
          const u = new URL(url, window.location.origin);
          if (!u.searchParams.get('autoplay')) u.searchParams.set('autoplay', '1');
          if (!u.searchParams.get('rel')) u.searchParams.set('rel', '0');
          return u.toString();
        } catch (_) {
          return url + (url.includes('?') ? '&' : '?') + 'autoplay=1&rel=0';
        }
      };

      const openModal = () => {
        const videoUrl = trigger.getAttribute('data-na-tvc-video-url') || '';
        if (!videoUrl.trim()) return;
        iframe.src = withAutoplay(videoUrl);
        modal.removeAttribute('hidden');
        modal.setAttribute('aria-hidden', 'false');
      };

      const closeModal = () => {
        modal.setAttribute('hidden', '');
        modal.setAttribute('aria-hidden', 'true');
        iframe.src = '';
      };

      const onTrigger = (e) => {
        e.preventDefault();
        openModal();
      };
      trigger.addEventListener('click', onTrigger);
      cleanups.push(() => trigger.removeEventListener('click', onTrigger));

      closeBtns.forEach((btn) => {
        const onClose = (e) => {
          e.preventDefault();
          closeModal();
        };
        btn.addEventListener('click', onClose);
        cleanups.push(() => btn.removeEventListener('click', onClose));
      });

      const onEsc = (e) => {
        if (!(e instanceof KeyboardEvent)) return;
        if (e.key !== 'Escape') return;
        if (modal.hasAttribute('hidden')) return;
        closeModal();
      };
      document.addEventListener('keydown', onEsc);
      cleanups.push(() => document.removeEventListener('keydown', onEsc));
    });
  }

  function initNexodeAirLaunchCampaignGleam(root, ctx) {
    const { cleanups } = ctx;
    root.querySelectorAll('[data-na-launch-campaign]').forEach((section) => {
      if (!(section instanceof HTMLElement)) return;

      const trigger = section.querySelector('[data-na-launch-gleam-trigger]');
      const modal = section.querySelector('[data-na-launch-gleam-modal]');
      if (!(trigger instanceof HTMLAnchorElement) || !(modal instanceof HTMLElement)) return;

      const closeButtons = Array.from(section.querySelectorAll('[data-na-launch-gleam-close]')).filter(
        (el) => el instanceof HTMLElement
      );

      const gleamAnchor = modal.querySelector('.e-widget.no-button');
      const gleamUrl = String(trigger.getAttribute('data-na-launch-gleam-url') || '').trim();
      const modalOriginalParent = modal.parentElement;
      if (gleamAnchor instanceof HTMLAnchorElement && gleamUrl) {
        gleamAnchor.setAttribute('href', gleamUrl);
      }

      const ensureGleamScript = () => {
        if (document.querySelector('script[src*="widget.gleamjs.io/e.js"]')) {
          return;
        }
        const script = document.createElement('script');
        script.src = 'https://widget.gleamjs.io/e.js';
        script.async = true;
        document.body.appendChild(script);
      };

      const openModal = () => {
        if (modal.parentElement !== document.body) {
          document.body.appendChild(modal);
        }
        modal.classList.remove('dpn');
        modal.removeAttribute('hidden');
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('na-modal-open');
        document.body.classList.add('na-modal-open');
        ensureGleamScript();
      };

      const closeModal = () => {
        modal.classList.add('dpn');
        modal.setAttribute('hidden', '');
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('na-modal-open');
        document.body.classList.remove('na-modal-open');
      };

      const onTriggerClick = (e) => {
        const isGleamLink = /gleam\.io/i.test(gleamUrl);
        if (!isGleamLink) {
          return;
        }
        e.preventDefault();
        openModal();
      };
      trigger.addEventListener('click', onTriggerClick);
      cleanups.push(() => trigger.removeEventListener('click', onTriggerClick));

      closeButtons.forEach((btn) => {
        const onCloseClick = (e) => {
          e.preventDefault();
          closeModal();
        };
        btn.addEventListener('click', onCloseClick);
        cleanups.push(() => btn.removeEventListener('click', onCloseClick));
      });

      const onEsc = (e) => {
        if (!(e instanceof KeyboardEvent)) return;
        if (e.key !== 'Escape') return;
        if (modal.hasAttribute('hidden')) return;
        closeModal();
      };
      document.addEventListener('keydown', onEsc);
      cleanups.push(() => document.removeEventListener('keydown', onEsc));
      cleanups.push(() => {
        closeModal();
        if (modalOriginalParent instanceof HTMLElement && modal.parentElement !== modalOriginalParent) {
          modalOriginalParent.appendChild(modal);
        }
      });
    });
  }

  function naEditionsFormatMoney(cents) {
    const n = Number(cents);
    if (!Number.isFinite(n)) return '';
    return String(n / 100);
  }

  function naEditionsParseRows(scriptEl) {
    if (!(scriptEl instanceof HTMLScriptElement) || !scriptEl.textContent) return [];
    const raw = scriptEl.textContent.trim();
    if (!raw) return [];
    try {
      const out = JSON.parse(raw);
      return Array.isArray(out) ? out : [];
    } catch (_) {
      try {
        const arrStart = raw.indexOf('[');
        const arrEnd = raw.lastIndexOf(']');
        if (arrStart < 0 || arrEnd < arrStart) return [];
        return JSON.parse(raw.slice(arrStart, arrEnd + 1)) || [];
      } catch (__) {
        return [];
      }
    }
  }

  function initNexodeAirEditionsSwiper(root, ctx) {
    const { cleanups } = ctx;
    const section = root.querySelector('.ug-nexode-air-template__editions');
    const el = section && section.querySelector('[data-na-editions-swiper]');
    if (!section || !(el instanceof HTMLElement)) return;

    const navWrap = section.querySelector('[data-na-editions-nav]');
    const prev = section.querySelector('[data-na-editions-nav-prev]');
    const next = section.querySelector('[data-na-editions-nav-next]');
    const DESKTOP_MQ = '(min-width: 1024px)';
    let swiper = null;
    let resizeT = 0;
    let swiperWait = 0;

    const getSlideCount = () => el.querySelectorAll('.swiper-slide').length;

    const mount = () => {
      if (typeof window.Swiper !== 'function') return;
      const mq = window.matchMedia(DESKTOP_MQ);
      if (!mq.matches) {
        if (swiper) {
          try {
            swiper.destroy(true, true);
          } catch (_) {}
          swiper = null;
        }
        section.classList.remove('is-editions-swiper-inited');
        if (navWrap instanceof HTMLElement) {
          navWrap.classList.remove('is-visible');
          navWrap.setAttribute('aria-hidden', 'true');
        }
        return;
      }

      const c = getSlideCount();
      if (c < 1) return;

      if (swiper) {
        try {
          swiper.destroy(true, true);
        } catch (_) {}
        swiper = null;
      }

      const showNav = c > 4;
      if (navWrap instanceof HTMLElement) {
        if (showNav) {
          navWrap.classList.add('is-visible');
          navWrap.setAttribute('aria-hidden', 'false');
        } else {
          navWrap.classList.remove('is-visible');
          navWrap.setAttribute('aria-hidden', 'true');
        }
      }

      const opts = {
        spaceBetween: 20,
        watchOverflow: true,
        watchSlidesProgress: true,
        slidesPerView: c < 4 ? 'auto' : 4,
        centeredSlides: c < 4,
        centeredSlidesBounds: c < 4,
        on: {
          init: function () {
            scheduleNexodeAirTemplateScrollTriggerRefresh();
          },
          slideChange: function () {
            scheduleNexodeAirTemplateScrollTriggerRefresh();
          }
        }
      };

      if (showNav && prev && next) {
        opts.navigation = { prevEl: prev, nextEl: next };
      }

      try {
        swiper = new window.Swiper(el, opts);
        section.classList.add('is-editions-swiper-inited');
        scheduleNexodeAirTemplateScrollTriggerRefresh();
      } catch (err) {
        try {
          console.error('Nexode Air editions Swiper', err);
        } catch (_) {}
      }
    };

    const onResize = () => {
      clearTimeout(resizeT);
      resizeT = window.setTimeout(mount, 220);
    };

    if (typeof window.Swiper === 'function') {
      mount();
    } else {
      swiperWait = window.setInterval(() => {
        if (typeof window.Swiper === 'function') {
          clearInterval(swiperWait);
          swiperWait = 0;
          mount();
        }
      }, 80);
      const waitMax = window.setTimeout(() => {
        if (swiperWait) {
          clearInterval(swiperWait);
          swiperWait = 0;
        }
      }, 10000);
      cleanups.push(() => clearTimeout(waitMax));
    }

    window.addEventListener('resize', onResize);
    cleanups.push(() => {
      clearTimeout(resizeT);
      if (swiperWait) clearInterval(swiperWait);
      window.removeEventListener('resize', onResize);
      if (swiper) {
        try {
          swiper.destroy(true, true);
        } catch (_) {}
        swiper = null;
      }
      section.classList.remove('is-editions-swiper-inited');
    });
  }

  function initNexodeAirEditionsMoViewMore(root, ctx) {
    const { cleanups } = ctx;
    const section = root.querySelector(
      '.ug-nexode-air-template__editions[data-na-editions-has-many]'
    );
    const btn = section && section.querySelector('[data-na-editions-mo-view-more]');
    if (!section || !(btn instanceof HTMLButtonElement)) return;

    const onClick = () => {
      section.classList.add('is-na-mo-expanded');
      btn.setAttribute('aria-expanded', 'true');
      try {
        scheduleNexodeAirTemplateScrollTriggerRefresh();
      } catch (_) {}
    };

    btn.addEventListener('click', onClick);
    cleanups.push(() => {
      try {
        btn.removeEventListener('click', onClick);
      } catch (_) {}
    });
  }

  function initNexodeAirEditionsCards(root, ctx) {
    const { cleanups, reduced: prefersReduced } = ctx;
    const cards = root.querySelectorAll('[data-na-editions-card]');
    if (!cards.length) return;

    cards.forEach((card) => {
      if (!(card instanceof HTMLElement)) return;
      const script = card.querySelector('script[data-na-editions-data]');
      const rows = naEditionsParseRows(script);
      if (!Array.isArray(rows) || !rows.length) return;

      const imgEl = card.querySelector('[data-na-editions-img]');
      const priceEl = card.querySelector('[data-na-editions-price]');
      const compareEl = card.querySelector('[data-na-editions-compare]');
      const surfaceEl = card.querySelector('[data-na-editions-surface]');

      const PRESETS = ['peach', 'gray', 'paper', 'mist', 'pink'];
      const VARIANT_FADE_MS = 280;
      let variantFadeGen = 0;

      const findRow = (variantId) => {
        const s = String(variantId).trim();
        const n = /^\d+$/.test(s) ? parseInt(s, 10) : NaN;
        const hit = rows.find((r) => {
          if (r == null) return false;
          if (String(r.id).trim() === s) return true;
          if (!Number.isNaN(n) && Number(r.id) === n) return true;
          return false;
        });
        return hit || rows[0];
      };

      const applyRowCore = (row, swatchEl) => {
        if (!row) return;
        if (imgEl instanceof HTMLImageElement && row.image) {
          imgEl.src = row.image;
          imgEl.removeAttribute('srcset');
        }
        if (imgEl instanceof HTMLImageElement) {
          imgEl.style.removeProperty('opacity');
        }
        if (priceEl) {
          const pt = row && row.price_text;
          if (pt != null && String(pt).trim() !== '') {
            priceEl.textContent = String(pt).trim();
          } else {
            priceEl.textContent = naEditionsFormatMoney(row.price_cents);
          }
        }
        if (compareEl) {
          const ct = row && row.compare_text;
          if (ct != null && String(ct).trim() !== '' && String(ct) !== 'null') {
            compareEl.textContent = String(ct).trim();
            compareEl.removeAttribute('hidden');
          } else {
            const cc = row.compare_cents;
            const pc = row.price_cents;
            if (cc != null && pc != null && Number(cc) > Number(pc)) {
              compareEl.textContent = naEditionsFormatMoney(cc);
              compareEl.removeAttribute('hidden');
            } else {
              compareEl.textContent = '';
              compareEl.setAttribute('hidden', '');
            }
          }
        }
        PRESETS.forEach((p) => card.classList.remove(`is-preset-${p}`));
        card.classList.remove('is-swatch-bg');
        if (surfaceEl instanceof HTMLElement) {
          surfaceEl.style.removeProperty('--edc-variant-swatch');
        }
        const presetFromRow = row.preset && String(row.preset).trim();
        const presetFromSwatch =
          swatchEl instanceof HTMLElement ? swatchEl.getAttribute('data-preset') : '';
        const preset = presetFromRow || (presetFromSwatch ? String(presetFromSwatch).trim() : '');
        if (preset && PRESETS.includes(preset)) {
          card.classList.add(`is-preset-${preset}`);
        }
      };

      const applyRow = (row, swatchEl) => {
        if (!row) return;
        const useFade = swatchEl instanceof HTMLElement && !prefersReduced;
        if (!useFade) {
          card.classList.remove('is-editions-variant-fade');
          applyRowCore(row, swatchEl);
          return;
        }
        const myGen = ++variantFadeGen;
        card.classList.add('is-editions-variant-fade');
        window.setTimeout(() => {
          if (myGen !== variantFadeGen) return;
          const endFade = () => {
            if (myGen !== variantFadeGen) return;
            requestAnimationFrame(() => {
              if (myGen !== variantFadeGen) return;
              card.classList.remove('is-editions-variant-fade');
            });
          };
          if (imgEl instanceof HTMLImageElement && row.image) {
            const onDone = () => {
              if (imgEl) {
                imgEl.removeEventListener('load', onDone);
                imgEl.removeEventListener('error', onDone);
              }
              endFade();
            };
            imgEl.addEventListener('load', onDone, { once: true });
            imgEl.addEventListener('error', onDone, { once: true });
            applyRowCore(row, swatchEl);
            if (imgEl.complete) onDone();
          } else {
            applyRowCore(row, swatchEl);
            endFade();
          }
        }, VARIANT_FADE_MS);
      };

      const onCardPointer = (e) => {
        const t = e.target;
        if (!(t instanceof Element)) return;
        const sw = t.closest('[data-na-editions-swatch]');
        if (!sw || !card.contains(sw)) return;
        const id = sw.getAttribute('data-variant-id');
        if (id == null || String(id).trim() === '') return;
        card.querySelectorAll('[data-na-editions-swatch]').forEach((x) => {
          const active = x === sw;
          x.classList.toggle('is-selected', active);
          x.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        applyRow(findRow(id), sw);
      };
      card.addEventListener('click', onCardPointer, true);
      cleanups.push(() => card.removeEventListener('click', onCardPointer, true));

      applyRowCore(rows[0], null);
    });
  }

  function initNexodeAirChargePromo(root, ctx) {
    const { cleanups, reduced } = ctx;
    const chargeSections = root.querySelectorAll('section.ug-nexode-air-template__charge-promo[data-na-charge-promo]');
    if (!chargeSections.length) return;

    const gsap = window.gsap;
    const ScrollTrigger = window.ScrollTrigger;
    const mqMobile =
      typeof window.matchMedia === 'function' ? window.matchMedia(MOBILE_MQ) : null;
    const isMobileNow = () => Boolean(mqMobile && mqMobile.matches);

    const activateCssMeters = (section) => {
      section.classList.add('is-charge-promo-meters-active');
    };

    const readMeterPct = (el) => {
      const raw =
        typeof el.style.getPropertyValue === 'function' ? el.style.getPropertyValue('--meter-pct').trim() : '';
      const n = parseFloat(raw);
      return Number.isFinite(n) ? Math.min(100, Math.max(0, n)) * 0.01 : 0;
    };

    chargeSections.forEach((section) => {
      if (!(section instanceof HTMLElement)) return;

      if (reduced) {
        section.classList.add('is-reduced-motion', 'is-charge-promo-static-desk');
        activateCssMeters(section);
        return;
      }

      if (isMobileNow()) {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((en) => {
              if (!en.isIntersecting) return;
              activateCssMeters(section);
              io.disconnect();
            });
          },
          { root: null, threshold: 0.12, rootMargin: '0px 0px -10% 0px' }
        );
        io.observe(section);
        cleanups.push(() => {
          try {
            io.disconnect();
          } catch (_) {}
        });
        return;
      }

      const pin = section.querySelector('[data-na-charge-pin]');
      const spacer = section.querySelector('[data-na-charge-pin-spacer]');
      const track = section.querySelector('[data-na-charge-copy-track]');
      const clip = section.querySelector('.ug-nexode-air-template__charge-promo-copy-clip');
      const visA = section.querySelector('[data-na-charge-vis="a"]');
      const visB = section.querySelector('[data-na-charge-vis="b"]');

      if (!pin || !spacer || !track || !clip || !gsap || !ScrollTrigger) {
        section.classList.add('is-charge-promo-static-desk');
        activateCssMeters(section);
        return;
      }

      gsap.registerPlugin(ScrollTrigger);
      section.classList.add('is-charge-promo-pin-mode');

      const slides = track.querySelectorAll('.ug-nexode-air-template__charge-promo-slide');
      const s0 = slides[0];
      const s1 = slides[1];
      if (!(s0 instanceof HTMLElement) || !(s1 instanceof HTMLElement)) {
        section.classList.remove('is-charge-promo-pin-mode');
        section.classList.add('is-charge-promo-static-desk');
        activateCssMeters(section);
        return;
      }

      const visStack = section.querySelector('.ug-nexode-air-template__charge-promo-vis-stack');
      const meterFillsA = Array.from(section.querySelectorAll('[data-na-charge-meter="a"]'));
      const meterFillsB = Array.from(section.querySelectorAll('[data-na-charge-meter="b"]'));

      const setMetersToZero = (fills) => {
        fills.forEach((el) => {
          if (!(el instanceof HTMLElement)) return;
          gsap.killTweensOf(el);
          gsap.set(el, { scaleX: 0, transformOrigin: 'left center' });
        });
      };

      const runMeterFillTween = (fills) => {
        fills.forEach((el, i) => {
          if (!(el instanceof HTMLElement)) return;
          gsap.killTweensOf(el);
          gsap.set(el, { scaleX: 0, transformOrigin: 'left center' });
          gsap.to(el, {
            scaleX: readMeterPct(el),
            duration: 0.88,
            delay: i * 0.08,
            ease: 'power2.out',
          });
        });
      };

      const CHARGE_VIS_FADE_SEC = 0.72;

      const runVisFade = (/** @type {'a'|'b'} */ phase) => {
        const showA = phase === 'a';
        if (visA instanceof HTMLElement) {
          gsap.killTweensOf(visA);
          gsap.to(visA, { opacity: showA ? 1 : 0, duration: CHARGE_VIS_FADE_SEC, ease: 'power2.out' });
          visA.setAttribute('aria-hidden', showA ? 'false' : 'true');
          visA.classList.toggle('is-on', showA);
        }
        if (visB instanceof HTMLElement) {
          gsap.killTweensOf(visB);
          gsap.to(visB, { opacity: showA ? 0 : 1, duration: CHARGE_VIS_FADE_SEC, ease: 'power2.out' });
          visB.setAttribute('aria-hidden', showA ? 'true' : 'false');
          visB.classList.toggle('is-on', !showA);
        }
      };

      /* 裁剪高度：左栏当前叠层与两屏文案（含 meter）取高；隐藏叠层 absolute 不参与撑高 */
      const applyClipHeight = () => {
        const fromVis = visStack instanceof HTMLElement ? visStack.offsetHeight : 0;
        const minReadable = Math.max(s0.scrollHeight, s1.scrollHeight, 280);
        const h = Math.max(fromVis, minReadable);
        clip.style.height = `${h}px`;
        s0.style.minHeight = `${h}px`;
        s1.style.minHeight = `${h}px`;
      };

      setMetersToZero(meterFillsA);
      setMetersToZero(meterFillsB);
      if (visA instanceof HTMLElement) {
        gsap.set(visA, { opacity: 1 });
      }
      if (visB instanceof HTMLElement) {
        gsap.set(visB, { opacity: 0 });
      }
      gsap.set(track, { y: 0 });

      applyClipHeight();

      let ro = null;
      if (typeof ResizeObserver !== 'undefined') {
        ro = new ResizeObserver(() => {
          applyClipHeight();
          scheduleNexodeAirTemplateScrollTriggerRefresh();
        });
        if (visStack instanceof HTMLElement) ro.observe(visStack);
        ro.observe(s0);
        ro.observe(s1);
        section.querySelectorAll('.ug-nexode-air-template__charge-promo-vis-pic img').forEach((img) => {
          if (!(img instanceof Element)) return;
          ro.observe(img);
        });
        cleanups.push(() => {
          try {
            ro.disconnect();
          } catch (_) {}
        });
      }

      const multRaw = section.getAttribute('data-na-charge-pin-mult');
      const mult = Math.max(1.05, Math.min(5, parseFloat(multRaw || '1.65') || 1.65));

      const PHASE_B_ENTER = 0.9;
      const PHASE_A_ENTER = 0.12;

      let chargeCopyPhase = null;

      const applyChargeCopyPhase = (next) => {
        if (next !== 'a' && next !== 'b') return;
        if (chargeCopyPhase === next) return;
        chargeCopyPhase = next;
        runVisFade(next);
        if (next === 'a') {
          setMetersToZero(meterFillsB);
          runMeterFillTween(meterFillsA);
        } else {
          setMetersToZero(meterFillsA);
          runMeterFillTween(meterFillsB);
        }
      };

      const syncChargePhaseFromProgress = (p) => {
        if (p >= PHASE_B_ENTER) applyChargeCopyPhase('b');
        else if (p <= PHASE_A_ENTER) applyChargeCopyPhase('a');
        else if (chargeCopyPhase === null) applyChargeCopyPhase(p >= 0.5 ? 'b' : 'a');
      };

      const tween = gsap.to(track, {
        y: () => -Math.max(0, clip.offsetHeight || 0),
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top top',
          end: () => `+=${window.innerHeight * mult}`,
          pin: pin,
          pinSpacing: true,
          scrub: NA_CHARGE_PROMO_SCRUB_SEC,
          anticipatePin: 1,
          invalidateOnRefresh: true,
          onUpdate: (self) => syncChargePhaseFromProgress(self.progress),
        },
      });

      requestAnimationFrame(() => {
        try {
          const st = tween.scrollTrigger;
          if (st) syncChargePhaseFromProgress(st.progress);
        } catch (_) {}
      });

      cleanups.push(() => {
        try {
          const stKill = tween.scrollTrigger;
          if (stKill && typeof stKill.kill === 'function') stKill.kill();
        } catch (_) {}
        try {
          tween.kill();
        } catch (_) {}
        clip.style.height = '';
        s0.style.minHeight = '';
        s1.style.minHeight = '';
        try {
          gsap.set(track, { clearProps: 'transform' });
        } catch (_) {}
        section.classList.remove('is-charge-promo-pin-mode');
      });

      scheduleNexodeAirTemplateScrollTriggerRefresh();
    });
  }

  function initNexodeTravelKit(root, ctx) {
    const { cleanups, reduced: travelKitReduced } = ctx;

    const bindAccordion = (accRoot, heroStack, accOpts) => {
      const items = Array.from(accRoot.querySelectorAll('[data-na-travel-acc-item]'));
      if (!items.length) {
        return;
      }
      const gsap = window.gsap;
      const useMotion = Boolean(gsap) && !accOpts.reduced;

      const setItemVisualState = (/** @type {HTMLElement} */ item, /** @type {boolean} */ open) => {
        item.classList.toggle('is-open', open);
        const trigger = item.querySelector('[data-na-travel-acc-trigger]');
        if (trigger instanceof HTMLElement) {
          trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        const titleEl = item.querySelector('.ug-nexode-air-template__travel-kit-acc-title');
        if (titleEl instanceof HTMLElement) {
          titleEl.classList.toggle('ug-nexode-air-template__travel-kit-acc-title--collapsed', !open);
        }
        const panel = item.querySelector('.ug-nexode-air-template__travel-kit-acc-panel');
        if (panel instanceof HTMLElement) {
          panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        }
      };

      const switchTravelHeroLayers = (panel) => {
        if (!(heroStack instanceof HTMLElement)) {
          return;
        }
        const p = String(panel);
        if (String(heroStack.dataset.naTravelPanel || '1') === p) {
          return;
        }
        const layers = heroStack.querySelectorAll('[data-na-travel-hero-layer]');
        if (!layers.length) {
          return;
        }
        let hit = false;
        layers.forEach((node) => {
          if (!(node instanceof HTMLElement)) {
            return;
          }
          const lp = node.getAttribute('data-na-travel-hero-layer') || '';
          const on = lp === p;
          if (on) {
            hit = true;
          }
          node.classList.toggle('is-active', on);
        });
        if (hit) {
          heroStack.dataset.naTravelPanel = p;
        }
      };

      const staggerPanelContent = (panelEl) => {
        if (!useMotion || !gsap) {
          return;
        }
        // 内容在 acc-panel-inner 内，以 inner 为 :scope 根节点做子级 stagger
        const innerEl =
          panelEl.querySelector(':scope > .ug-nexode-air-template__travel-kit-acc-panel-inner') ||
          panelEl;
        const parts = innerEl.querySelectorAll(
          ':scope > .ug-nexode-air-template__travel-kit-desc--acc, :scope > .ug-nexode-air-template__travel-kit-desc--plain, :scope > p, :scope > .ug-nexode-air-template__travel-kit-chips, :scope > .ug-nexode-air-template__travel-kit-mo-hero'
        );
        if (!parts.length) {
          return;
        }
        gsap.fromTo(
          parts,
          { opacity: 0, y: 8 },
          {
            opacity: 1,
            y: 0,
            duration: 0.48,
            stagger: 0.1,
            ease: 'power3.out',
            delay: 0.08,
            clearProps: 'opacity,transform',
          }
        );
      };

      const openPanelIndex = (/** @type {number} */ targetIdx) => {
        items.forEach((node, idx) => {
          if (!(node instanceof HTMLElement)) {
            return;
          }
          const wasOpen = node.classList.contains('is-open');
          const willOpen = idx === targetIdx;
          setItemVisualState(node, willOpen);
          if (willOpen && !wasOpen) {
            const panelEl = node.querySelector('.ug-nexode-air-template__travel-kit-acc-panel');
            if (panelEl instanceof HTMLElement) {
              staggerPanelContent(panelEl);
            }
          }
          if (idx === targetIdx && heroStack) {
            const panel = node.getAttribute('data-panel') || '1';
            switchTravelHeroLayers(panel);
          }
        });
      };

      const onTriggerClick = (ev) => {
        const t = ev.currentTarget;
        if (!(t instanceof HTMLElement)) {
          return;
        }
        const item = t.closest('[data-na-travel-acc-item]');
        if (!(item instanceof HTMLElement)) {
          return;
        }
        const idx = items.indexOf(item);
        if (idx < 0) {
          return;
        }
        if (item.classList.contains('is-open')) {
          return;
        }

        openPanelIndex(idx);
      };

      items.forEach((node) => {
        const triggers = node.querySelectorAll('[data-na-travel-acc-trigger]');
        triggers.forEach((tr) => {
          tr.addEventListener('click', onTriggerClick);
          cleanups.push(() => tr.removeEventListener('click', onTriggerClick));
        });
      });
    };

    root.querySelectorAll('[data-na-travel-kit]').forEach((section) => {
      if (!(section instanceof HTMLElement)) {
        return;
      }

      const slide = section.querySelector('[data-na-travel-kit-slide]');
      if (slide instanceof HTMLElement) {
        const desktop = slide.querySelector('[data-na-travel-desktop]');
        const heroStack = slide.querySelector('[data-na-travel-hero-stack]');
        if (desktop instanceof HTMLElement) {
          const acc = desktop.querySelector('[data-na-travel-acc]');
          if (acc instanceof HTMLElement) {
            if (heroStack instanceof HTMLElement) {
              heroStack.dataset.naTravelPanel = '1';
            }
            bindAccordion(
              acc,
              heroStack instanceof HTMLElement ? heroStack : null,
              { reduced: travelKitReduced }
            );
          }
        }
      }

      section.querySelectorAll('[data-na-travel-kit-mo-root] [data-na-travel-acc-mo]').forEach((accMo) => {
        if (accMo instanceof HTMLElement) {
          bindAccordion(accMo, null, { reduced: travelKitReduced });
        }
      });
    });
  }

  function initNexodeDesignCare(root, ctx) {
    const { cleanups, reduced } = ctx;

    root.querySelectorAll('[data-na-design-care]').forEach((section) => {
      if (!(section instanceof HTMLElement)) {
        return;
      }

      const pcRoot = section.querySelector('[data-na-design-care-pc]');
      const panels = pcRoot
        ? Array.from(pcRoot.querySelectorAll('[data-na-design-care-panel]')).filter((el) => el instanceof HTMLElement)
        : [];

      const setExpandedPanel = (/** @type {HTMLElement | null} */ target) => {
        if (!target || !panels.includes(target)) {
          return;
        }
        panels.forEach((p) => {
          p.classList.toggle('is-expanded', p === target);
        });
      };

      if (panels.length >= 2 && pcRoot instanceof HTMLElement) {
        const first = panels[0];
        panels.forEach((p) => {
          const onEnter = () => setExpandedPanel(p);
          p.addEventListener('mouseenter', onEnter);
          p.addEventListener('focusin', onEnter);
          cleanups.push(() => p.removeEventListener('mouseenter', onEnter));
          cleanups.push(() => p.removeEventListener('focusin', onEnter));
        });
        setExpandedPanel(first);
      }

      const viewport = section.querySelector('[data-na-design-care-mo-viewport]');
      const track = section.querySelector('[data-na-design-care-mo-track]');
      const slides = Array.from(section.querySelectorAll('[data-na-design-care-mo-slide]')).filter(
        (el) => el instanceof HTMLElement
      );

      if (!(viewport instanceof HTMLElement) || !(track instanceof HTMLElement) || slides.length === 0) {
        return;
      }

      const realCount = slides.length;
      let currentSlide = 0;
      let isDragging = false;
      let dragPointerId = null;
      let dragStartX = 0;
      let dragBaseX = 0;
      let dragDeltaX = 0;

      const getTargetTranslateX = (slideIndex) => {
        const card = slides[slideIndex];
        if (!(card instanceof HTMLElement) || viewport.clientWidth <= 0) {
          return 0;
        }
        const V = viewport.clientWidth;
        // 首张：轨道起点与视口左对齐
        if (slideIndex === 0) {
          return 0;
        }
        // 非首张：左对齐当前卡（取消居中，避免两侧留白）；末张再与轨道右缘对齐视口，去掉右侧「死边」
        let tx = -card.offsetLeft;
        if (slideIndex === realCount - 1) {
          const W = track.scrollWidth;
          const flushRight = V - W;
          if (flushRight < 0) {
            tx = Math.min(tx, flushRight);
          }
        }
        return tx;
      };

      const getCurrentTranslateX = () => {
        const tf = window.getComputedStyle(track).transform;
        if (!tf || tf === 'none') {
          return getTargetTranslateX(currentSlide);
        }
        const m2d = tf.match(/^matrix\((.+)\)$/);
        if (m2d && m2d[1]) {
          const parts = m2d[1].split(',').map((s) => Number.parseFloat(s.trim()));
          return Number.isFinite(parts[4]) ? parts[4] : getTargetTranslateX(currentSlide);
        }
        const m3d = tf.match(/^matrix3d\((.+)\)$/);
        if (m3d && m3d[1]) {
          const parts = m3d[1].split(',').map((s) => Number.parseFloat(s.trim()));
          return Number.isFinite(parts[12]) ? parts[12] : getTargetTranslateX(currentSlide);
        }
        return getTargetTranslateX(currentSlide);
      };

      const updateTrackTranslate = (immediate, slideIndex = currentSlide) => {
        const targetX = getTargetTranslateX(slideIndex);
        if (immediate || reduced) {
          track.style.transition = 'none';
          if (targetX === 0) {
            track.style.removeProperty('transform');
          } else {
            track.style.transform = `translate3d(${targetX}px, 0, 0)`;
          }
          window.requestAnimationFrame(() => {
            track.style.removeProperty('transition');
          });
          return;
        }
        track.style.transform = `translate3d(${targetX}px, 0, 0)`;
      };

      const shiftSlide = (delta) => {
        currentSlide = Math.max(0, Math.min(currentSlide + delta, realCount - 1));
        updateTrackTranslate(false, currentSlide);
      };

      const onPointerDown = (ev) => {
        if (!(ev instanceof PointerEvent) || realCount <= 1) {
          return;
        }
        if (ev.pointerType === 'mouse' && ev.button !== 0) {
          return;
        }
        isDragging = true;
        dragPointerId = ev.pointerId;
        dragStartX = ev.clientX;
        dragDeltaX = 0;
        dragBaseX = getCurrentTranslateX();
        track.style.transition = 'none';
        section.classList.add('is-design-care-dragging');
        try {
          viewport.setPointerCapture(ev.pointerId);
        } catch (_) {}
        ev.preventDefault();
      };

      const onPointerMove = (ev) => {
        if (!(ev instanceof PointerEvent) || !isDragging || dragPointerId !== ev.pointerId) {
          return;
        }
        dragDeltaX = ev.clientX - dragStartX;
        track.style.transform = `translate3d(${dragBaseX + dragDeltaX}px, 0, 0)`;
      };

      const finishDrag = (ev) => {
        if (!(ev instanceof PointerEvent) || !isDragging || dragPointerId !== ev.pointerId) {
          return;
        }
        isDragging = false;
        dragPointerId = null;
        section.classList.remove('is-design-care-dragging');
        try {
          viewport.releasePointerCapture(ev.pointerId);
        } catch (_) {}
        track.style.removeProperty('transition');
        const threshold = Math.max(40, viewport.clientWidth * 0.08);
        if (Math.abs(dragDeltaX) >= threshold) {
          shiftSlide(dragDeltaX < 0 ? 1 : -1);
        } else {
          updateTrackTranslate(false, currentSlide);
        }
        dragDeltaX = 0;
      };

      viewport.addEventListener('pointerdown', onPointerDown);
      viewport.addEventListener('pointermove', onPointerMove);
      viewport.addEventListener('pointerup', finishDrag);
      viewport.addEventListener('pointercancel', finishDrag);
      cleanups.push(() => viewport.removeEventListener('pointerdown', onPointerDown));
      cleanups.push(() => viewport.removeEventListener('pointermove', onPointerMove));
      cleanups.push(() => viewport.removeEventListener('pointerup', finishDrag));
      cleanups.push(() => viewport.removeEventListener('pointercancel', finishDrag));

      const onResize = () => updateTrackTranslate(true);
      window.addEventListener('resize', onResize, { passive: true });
      cleanups.push(() => window.removeEventListener('resize', onResize));

      updateTrackTranslate(true, 0);
    });
  }

  function initNexodeTravelScene(root, ctx) {
    const { cleanups, reduced } = ctx;
    root.querySelectorAll('[data-na-travel-scene]').forEach((section) => {
      if (!(section instanceof HTMLElement)) {
              return;
            }
      const viewport = section.querySelector('[data-na-travel-scene-viewport]');
      const track = section.querySelector('[data-na-travel-scene-track]');
      const tabs = Array.from(section.querySelectorAll('[data-na-travel-scene-tab]'));
      const cards = Array.from(section.querySelectorAll('[data-na-travel-scene-card]')).filter((card) => card instanceof HTMLElement);
      if (!(viewport instanceof HTMLElement) || !(track instanceof HTMLElement) || !tabs.length || !cards.length) {
        return;
      }

      const realCount = cards.length;
      const loopEnabled = realCount > 1;
      let autoTimer = 0;

      if (loopEnabled) {
        const firstClone = cards[0].cloneNode(true);
        const lastClone = cards[realCount - 1].cloneNode(true);
        const resetClonedBuyDropdowns = (cloneRoot) => {
          cloneRoot.querySelectorAll('[data-na-buy-dropdown]').forEach((w) => {
            if (!(w instanceof HTMLElement)) return;
            w.classList.remove('is-open');
            const t = w.querySelector('[data-na-buy-dropdown-toggle]');
            const p = w.querySelector('[data-na-buy-dropdown-panel]');
            if (t instanceof HTMLElement) {
              t.setAttribute('aria-expanded', 'false');
              t.removeAttribute('aria-controls');
            }
            if (p instanceof HTMLElement) {
              p.removeAttribute('id');
              p.hidden = true;
              /* 深拷贝可能带上主卡已 init 的 data-*，清掉避免克隆节点残留下拉态 */
              delete p.dataset.naDdMounted;
              delete p.dataset.naDdInteractive;
            }
          });
        };

        if (firstClone instanceof HTMLElement) {
          firstClone.removeAttribute('data-scene-index');
          firstClone.classList.remove('is-active');
          firstClone.setAttribute('aria-hidden', 'true');
          firstClone.setAttribute('data-na-travel-scene-clone', 'first');
          resetClonedBuyDropdowns(firstClone);
          track.appendChild(firstClone);
        }
        if (lastClone instanceof HTMLElement) {
          lastClone.removeAttribute('data-scene-index');
          lastClone.classList.remove('is-active');
          lastClone.setAttribute('aria-hidden', 'true');
          lastClone.setAttribute('data-na-travel-scene-clone', 'last');
          resetClonedBuyDropdowns(lastClone);
          track.insertBefore(lastClone, track.firstChild);
        }
      }

      const slides = Array.from(track.children).filter((slide) => slide instanceof HTMLElement);
      let currentSlide = loopEnabled ? 1 : 0;
      let activeIndex = 0;
      let isDragging = false;
      let dragPointerId = null;
      let dragStartX = 0;
      let dragBaseX = 0;
      let dragDeltaX = 0;

      const getRealIndexBySlide = (slideIndex) => {
        if (!loopEnabled) {
          return Math.max(0, Math.min(slideIndex, realCount - 1));
        }
        if (slideIndex <= 0) {
          return realCount - 1;
        }
        if (slideIndex >= realCount + 1) {
          return 0;
        }
        return slideIndex - 1;
      };

      const getTargetTranslateX = (slideIndex) => {
        const activeCard = slides[slideIndex];
        if (!(activeCard instanceof HTMLElement) || viewport.clientWidth <= 0) {
          return 0;
        }
        const rawTarget = activeCard.offsetLeft + activeCard.offsetWidth / 2 - viewport.clientWidth / 2;
        return -rawTarget;
      };

      const getCurrentTranslateX = () => {
        const tf = window.getComputedStyle(track).transform;
        if (!tf || tf === 'none') {
          return getTargetTranslateX(currentSlide);
        }
        const m2d = tf.match(/^matrix\((.+)\)$/);
        if (m2d && m2d[1]) {
          const parts = m2d[1].split(',').map((s) => Number.parseFloat(s.trim()));
          return Number.isFinite(parts[4]) ? parts[4] : getTargetTranslateX(currentSlide);
        }
        const m3d = tf.match(/^matrix3d\((.+)\)$/);
        if (m3d && m3d[1]) {
          const parts = m3d[1].split(',').map((s) => Number.parseFloat(s.trim()));
          return Number.isFinite(parts[12]) ? parts[12] : getTargetTranslateX(currentSlide);
        }
        return getTargetTranslateX(currentSlide);
      };

      const updateUiBySlide = () => {
        activeIndex = getRealIndexBySlide(currentSlide);
        tabs.forEach((btn, i) => {
          if (!(btn instanceof HTMLElement)) {
            return;
          }
          const on = i === activeIndex;
          btn.classList.toggle('is-active', on);
          btn.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        cards.forEach((card, i) => {
          card.classList.toggle('is-active', i === activeIndex);
          });
        };

      const updateTrackTranslate = (immediate, slideIndex = currentSlide) => {
        const targetX = getTargetTranslateX(slideIndex);
        if (immediate) {
          track.style.transition = 'none';
          track.style.transform = `translate3d(${targetX}px, 0, 0)`;
          window.requestAnimationFrame(() => {
            track.style.removeProperty('transition');
          });
          return;
        }
        track.style.transform = `translate3d(${targetX}px, 0, 0)`;
      };

      const activateByRealIndex = (idx, immediate) => {
        const safeIdx = Math.max(0, Math.min(idx, realCount - 1));
        currentSlide = loopEnabled ? safeIdx + 1 : safeIdx;
        updateUiBySlide();
        updateTrackTranslate(immediate, currentSlide);
      };

      const shiftSlide = (delta) => {
        if (!loopEnabled) {
          const safe = Math.max(0, Math.min(currentSlide + delta, realCount - 1));
          currentSlide = safe;
        } else {
          currentSlide += delta;
        }
        updateUiBySlide();
        updateTrackTranslate(false, currentSlide);
      };

      const clearAutoPlay = () => {
        if (autoTimer) {
          window.clearInterval(autoTimer);
          autoTimer = 0;
        }
      };

      const startAutoPlay = () => {
        clearAutoPlay();
        if (realCount <= 1 || reduced) {
            return;
          }
        autoTimer = window.setInterval(() => {
          shiftSlide(1);
        }, 3800);
      };

      const restartAutoPlay = () => {
        startAutoPlay();
      };

      tabs.forEach((btn, idx) => {
        const onClick = () => {
          activateByRealIndex(idx, false);
          restartAutoPlay();
        };
        btn.addEventListener('click', onClick);
        cleanups.push(() => btn.removeEventListener('click', onClick));
      });

      const onTrackTransitionEnd = (ev) => {
        if (!(ev instanceof TransitionEvent) || ev.propertyName !== 'transform' || !loopEnabled) {
          return;
        }
        if (currentSlide === realCount + 1) {
          currentSlide = 1;
          updateUiBySlide();
          updateTrackTranslate(true, currentSlide);
        } else if (currentSlide === 0) {
          currentSlide = realCount;
          updateUiBySlide();
          updateTrackTranslate(true, currentSlide);
        }
      };
      track.addEventListener('transitionend', onTrackTransitionEnd);
      cleanups.push(() => track.removeEventListener('transitionend', onTrackTransitionEnd));

      const onResize = () => updateTrackTranslate(true);
      window.addEventListener('resize', onResize, { passive: true });
      cleanups.push(() => window.removeEventListener('resize', onResize));

      const onPointerDown = (ev) => {
        if (!(ev instanceof PointerEvent) || realCount <= 1) {
          return;
        }
        const targetEl = ev.target instanceof Element ? ev.target : null;
        if (
          targetEl
          && targetEl.closest(
            '.ug-nexode-air-template__charge-promo-buy, a, button'
          )
        ) {
          return;
        }
        if (ev.pointerType === 'mouse' && ev.button !== 0) {
          return;
        }
        isDragging = true;
        dragPointerId = ev.pointerId;
        dragStartX = ev.clientX;
        dragDeltaX = 0;
        dragBaseX = getCurrentTranslateX();
        clearAutoPlay();
        track.style.transition = 'none';
        section.classList.add('is-travel-scene-dragging');
        try {
          viewport.setPointerCapture(ev.pointerId);
        } catch (_) {}
        ev.preventDefault();
      };

      const onPointerMove = (ev) => {
        if (!(ev instanceof PointerEvent) || !isDragging || dragPointerId !== ev.pointerId) {
          return;
        }
        dragDeltaX = ev.clientX - dragStartX;
        track.style.transform = `translate3d(${dragBaseX + dragDeltaX}px, 0, 0)`;
      };

      const finishDrag = (ev) => {
        if (!(ev instanceof PointerEvent) || !isDragging || dragPointerId !== ev.pointerId) {
          return;
        }
        isDragging = false;
        dragPointerId = null;
        section.classList.remove('is-travel-scene-dragging');
        try {
          viewport.releasePointerCapture(ev.pointerId);
        } catch (_) {}
        track.style.removeProperty('transition');
        const threshold = Math.max(40, viewport.clientWidth * 0.08);
        if (Math.abs(dragDeltaX) >= threshold) {
          shiftSlide(dragDeltaX < 0 ? 1 : -1);
        } else {
          updateTrackTranslate(false, currentSlide);
        }
        dragDeltaX = 0;
        restartAutoPlay();
      };

      viewport.addEventListener('pointerdown', onPointerDown);
      viewport.addEventListener('pointermove', onPointerMove);
      viewport.addEventListener('pointerup', finishDrag);
      viewport.addEventListener('pointercancel', finishDrag);
      cleanups.push(() => viewport.removeEventListener('pointerdown', onPointerDown));
      cleanups.push(() => viewport.removeEventListener('pointermove', onPointerMove));
      cleanups.push(() => viewport.removeEventListener('pointerup', finishDrag));
      cleanups.push(() => viewport.removeEventListener('pointercancel', finishDrag));

      const onMouseEnter = () => clearAutoPlay();
      const onMouseLeave = () => startAutoPlay();
      section.addEventListener('mouseenter', onMouseEnter);
      section.addEventListener('mouseleave', onMouseLeave);
      cleanups.push(() => section.removeEventListener('mouseenter', onMouseEnter));
      cleanups.push(() => section.removeEventListener('mouseleave', onMouseLeave));

      const onVisibilityChange = () => {
        if (document.hidden) {
          clearAutoPlay();
        } else {
          startAutoPlay();
        }
      };
      document.addEventListener('visibilitychange', onVisibilityChange);
      cleanups.push(() => document.removeEventListener('visibilitychange', onVisibilityChange));

      activateByRealIndex(0, true);
      startAutoPlay();
      cleanups.push(() => clearAutoPlay());
    });
  }

  function initNexodeAirKvNav(root, ctx) {
    const nav = root.querySelector('[data-na-kv-nav]');
    if (!(nav instanceof HTMLElement)) {
      return;
    }

    const kvEl = root.querySelector('[data-na-kv]') || root.querySelector('.ug-nexode-air-template__kv');

    const dropdownToggle = nav.querySelector('[data-na-kv-nav-dropdown-toggle]');
    const dropdownPanel = nav.querySelector('[data-na-kv-nav-dropdown]');

    let kvRevealThreshold = 0;
    let lastSy = window.scrollY || window.pageYOffset || 0;

    const measureKvRevealThreshold = () => {
      if (kvEl instanceof HTMLElement) {
        const rect = kvEl.getBoundingClientRect();
        const sy0 = window.scrollY || window.pageYOffset || 0;
        kvRevealThreshold = Math.max(0, Math.round(rect.bottom + sy0));
        return;
      }
      kvRevealThreshold = 0;
    };

    const closeDropdownForStickyHide = () => {
      nav.classList.remove('is-kv-dropdown-open');
      if (dropdownToggle instanceof HTMLElement) {
        dropdownToggle.setAttribute('aria-expanded', 'false');
      }
      if (dropdownPanel instanceof HTMLElement) {
        dropdownPanel.hidden = true;
      }
    };

    const finishLeave = () => {
      nav.removeEventListener('animationend', onLeaveAnimEnd);
      nav.classList.remove('is-kv-sticky', 'is-kv-sticky-leaving');
      nav.classList.add('is-kv-nav-before-kv');
      nav.setAttribute('aria-hidden', 'true');
      closeDropdownForStickyHide();
      lastSy = window.scrollY || window.pageYOffset || 0;
      window.requestAnimationFrame(() => {
        measureKvRevealThreshold();
      });
    };

    const onLeaveAnimEnd = (ev) => {
      if (!(ev instanceof AnimationEvent)) {
        return;
      }
      if (ev.target !== nav) {
        return;
      }
      if (ev.animationName !== 'ug-na-kv-nav-slide-out') {
        return;
      }
      finishLeave();
    };

    const startLeave = () => {
      if (!nav.classList.contains('is-kv-sticky') || nav.classList.contains('is-kv-sticky-leaving')) {
        return;
      }
      closeDropdownForStickyHide();
      if (ctx.reduced) {
        finishLeave();
        return;
      }
      nav.classList.add('is-kv-sticky-leaving');
      nav.addEventListener('animationend', onLeaveAnimEnd);
    };

    measureKvRevealThreshold();

    let ticking = false;
    const updateStickyState = () => {
      ticking = false;
      const sy = window.scrollY || window.pageYOffset || 0;
      const wantVisible = sy >= kvRevealThreshold;

      if (nav.classList.contains('is-kv-sticky-leaving')) {
        if (wantVisible) {
          nav.removeEventListener('animationend', onLeaveAnimEnd);
          nav.classList.remove('is-kv-sticky-leaving');
          nav.classList.add('is-kv-sticky');
        }
        lastSy = sy;
        return;
      }

      if (wantVisible) {
        if (nav.classList.contains('is-kv-nav-before-kv')) {
          nav.classList.remove('is-kv-nav-before-kv');
          nav.removeAttribute('aria-hidden');
          if (!ctx.reduced) {
            void nav.offsetHeight;
          }
          nav.classList.remove('is-kv-sticky-leaving');
          nav.classList.add('is-kv-sticky');
        } else if (!nav.classList.contains('is-kv-sticky')) {
          nav.classList.add('is-kv-sticky');
        }
      } else if (nav.classList.contains('is-kv-sticky')) {
        startLeave();
      } else if (!nav.classList.contains('is-kv-nav-before-kv')) {
        nav.classList.add('is-kv-nav-before-kv');
        nav.setAttribute('aria-hidden', 'true');
      }

      lastSy = sy;
    };

    const requestStickyUpdate = () => {
      if (ticking) {
        return;
      }
      ticking = true;
      window.requestAnimationFrame(updateStickyState);
    };

    const onResize = () => {
      measureKvRevealThreshold();
      requestStickyUpdate();
    };

    requestStickyUpdate();
    window.addEventListener('scroll', requestStickyUpdate, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    ctx.cleanups.push(() => window.removeEventListener('scroll', requestStickyUpdate));
    ctx.cleanups.push(() => window.removeEventListener('resize', onResize));
    ctx.cleanups.push(() => {
      nav.removeEventListener('animationend', onLeaveAnimEnd);
      nav.classList.remove('is-kv-sticky', 'is-kv-sticky-leaving', 'is-kv-nav-before-kv');
      nav.removeAttribute('aria-hidden');
    });

    if (dropdownToggle instanceof HTMLElement && dropdownPanel instanceof HTMLElement) {
      const mqMobile = window.matchMedia('(max-width: 1023.98px)');
      const dropdownLabel = nav.querySelector('[data-na-kv-nav-dropdown-label]');

      const getDropdownNavLabelText = (link) => {
        if (!(link instanceof HTMLElement)) {
          return '';
        }
        const textEl = link.querySelector('[data-na-kv-nav-campaign-label-text]');
        if (textEl instanceof HTMLElement) {
          return (textEl.textContent || '').trim();
        }
        return (link.textContent || '').trim();
      };

      const setDropdownCampaignLabelText = (text) => {
        if (!(dropdownLabel instanceof HTMLElement) || typeof text !== 'string') {
          return;
        }
        const textEl = dropdownLabel.querySelector('[data-na-kv-nav-campaign-label-text]');
        if (textEl instanceof HTMLElement) {
          textEl.textContent = text;
          return;
        }
        dropdownLabel.textContent = text;
      };

      const dropdownLinks = Array.from(dropdownPanel.querySelectorAll('.ug-nexode-air-template__kv-nav-dropdown-link'));
      const topNavLinks = Array.from(
        nav.querySelectorAll('.ug-nexode-air-template__kv-nav-link, .ug-nexode-air-template__kv-nav-campaign')
      );

      const getHashFromHref = (href) => {
        if (typeof href !== 'string' || href.length === 0) {
          return '';
        }
        if (href.startsWith('#')) {
          return href;
        }
        try {
          const url = new URL(href, window.location.href);
          return url.hash || '';
        } catch (_) {
          return '';
        }
      };

      const getTargetByHash = (hash) => {
        if (typeof hash !== 'string' || !hash.startsWith('#')) {
          return null;
        }
        const target = root.querySelector(hash) || document.querySelector(hash);
        return target instanceof HTMLElement ? target : null;
      };

      const scrollToTarget = (targetEl) => {
      if (!(targetEl instanceof HTMLElement)) {
        return;
      }
      const sy = window.scrollY || window.pageYOffset || 0;
      const navH = Math.max(0, Math.round(nav.getBoundingClientRect().height));
      const targetTop = targetEl.getBoundingClientRect().top + sy;
      const nextTop = Math.max(0, targetTop - navH - 8);
      window.scrollTo({
        top: nextTop,
        behavior: ctx.reduced ? 'auto' : 'smooth'
      });
    };

      const trackedItems = dropdownLinks
        .map((link) => {
          if (!(link instanceof HTMLAnchorElement)) {
            return null;
          }
          const hash = getHashFromHref(link.getAttribute('href') || '');
          const target = getTargetByHash(hash);
          const label = getDropdownNavLabelText(link);
          if (!hash || !(target instanceof HTMLElement) || !label) {
            return null;
          }
          return { link, hash, target, label };
        })
        .filter(Boolean);

      const setActiveMobileItem = (hash) => {
        if (typeof hash !== 'string' || hash.length === 0) {
        return;
      }
        dropdownLinks.forEach((link) => {
          if (link instanceof HTMLAnchorElement) {
            const linkHash = getHashFromHref(link.getAttribute('href') || '');
            link.classList.toggle('is-active', linkHash === hash);
          }
        });
        if (dropdownLabel instanceof HTMLElement) {
          const matched = trackedItems.find((item) => item.hash === hash);
          if (matched) {
            setDropdownCampaignLabelText(matched.label);
          }
        }
      };

      const syncMobileItemByScroll = () => {
        if (!mqMobile.matches || trackedItems.length === 0) {
          return;
        }
        const sy = window.scrollY || window.pageYOffset || 0;
        const navH = Math.max(0, Math.round(nav.getBoundingClientRect().height));
        const probeY = sy + navH + 18;
        let activeItem = trackedItems[0];
        trackedItems.forEach((item) => {
          const top = item.target.getBoundingClientRect().top + sy;
          if (top <= probeY) {
            activeItem = item;
          }
        });
        setActiveMobileItem(activeItem.hash);
      };

      const closeDropdown = () => {
        nav.classList.remove('is-kv-dropdown-open');
        dropdownToggle.setAttribute('aria-expanded', 'false');
        dropdownPanel.hidden = true;
      };

      const openDropdown = () => {
        nav.classList.add('is-kv-dropdown-open');
        dropdownToggle.setAttribute('aria-expanded', 'true');
        dropdownPanel.hidden = false;
      };

      const toggleDropdown = () => {
        if (nav.classList.contains('is-kv-dropdown-open')) {
          closeDropdown();
          return;
        }
        openDropdown();
      };

      closeDropdown();
      syncMobileItemByScroll();

      const onToggleClick = (ev) => {
      ev.preventDefault();
        toggleDropdown();
    };

      const onDocumentClick = (ev) => {
        if (!(ev.target instanceof Node)) {
        return;
      }
        if (!nav.contains(ev.target)) {
          closeDropdown();
        }
      };

      const onKeyDown = (ev) => {
        if (ev.key === 'Escape') {
          closeDropdown();
        }
      };

      let mobileSyncTicking = false;
      const requestMobileScrollSync = () => {
        if (mobileSyncTicking) {
          return;
        }
        mobileSyncTicking = true;
        window.requestAnimationFrame(() => {
          mobileSyncTicking = false;
          syncMobileItemByScroll();
        });
      };

      const onViewportChange = () => {
        if (!mqMobile.matches) {
          closeDropdown();
        }
        requestMobileScrollSync();
      };

      const onDropdownLinkClick = (ev) => {
        const link = ev.currentTarget;
        if (!(link instanceof HTMLAnchorElement)) {
          closeDropdown();
          return;
        }
        const hash = getHashFromHref(link.getAttribute('href') || '');
        const target = getTargetByHash(hash);
        if (target) {
      ev.preventDefault();
          setActiveMobileItem(hash);
          closeDropdown();
          scrollToTarget(target);
          return;
        }
        closeDropdown();
      };

      const onTopNavLinkClick = (ev) => {
        const link = ev.currentTarget;
        if (!(link instanceof HTMLAnchorElement)) {
          return;
        }
        const hash = getHashFromHref(link.getAttribute('href') || '');
        const target = getTargetByHash(hash);
        if (!target) {
          return;
        }
        ev.preventDefault();
        setActiveMobileItem(hash);
        scrollToTarget(target);
      };

      dropdownToggle.addEventListener('click', onToggleClick);
      document.addEventListener('click', onDocumentClick);
      document.addEventListener('keydown', onKeyDown);
      window.addEventListener('resize', onViewportChange, { passive: true });
      window.addEventListener('scroll', requestMobileScrollSync, { passive: true });
      dropdownLinks.forEach((link) => link.addEventListener('click', onDropdownLinkClick));
      topNavLinks.forEach((link) => link.addEventListener('click', onTopNavLinkClick));

      ctx.cleanups.push(() => dropdownToggle.removeEventListener('click', onToggleClick));
      ctx.cleanups.push(() => document.removeEventListener('click', onDocumentClick));
      ctx.cleanups.push(() => document.removeEventListener('keydown', onKeyDown));
      ctx.cleanups.push(() => window.removeEventListener('resize', onViewportChange));
      ctx.cleanups.push(() => window.removeEventListener('scroll', requestMobileScrollSync));
      ctx.cleanups.push(() => dropdownLinks.forEach((link) => link.removeEventListener('click', onDropdownLinkClick)));
      ctx.cleanups.push(() => topNavLinks.forEach((link) => link.removeEventListener('click', onTopNavLinkClick)));
      ctx.cleanups.push(() => closeDropdown());
    }
  }

  function initNexodeAirBuyDropdowns(root, ctx) {
    const { cleanups } = ctx;
    const wraps = root.querySelectorAll('[data-na-buy-dropdown]');
    if (!wraps.length) return;

    /* 旅行场景无限轮播克隆卡：不参与下拉逻辑，避免与主卡重复绑定 */
    const isTravelSceneClone = (el) =>
      !!(el instanceof Element && el.closest('[data-na-travel-scene-clone]'));

    const mqBuyDdDesk =
      typeof window.matchMedia === 'function' ? window.matchMedia('(min-width: 1024px)') : null;
    const mqBuyDdMobile =
      typeof window.matchMedia === 'function' ? window.matchMedia('(max-width: 1023.98px)') : null;

    const prefersHoverOpen =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
      (!mqBuyDdDesk || mqBuyDdDesk.matches);

    /* hover 离开按钮与面板之间有绝对定位空隙，会误触 mouseleave；延迟略短减轻「拖沓」感 */
    const hoverLeaveTimers = new WeakMap();
    const HOVER_LEAVE_MS = 160;

    /* 手机弹层挂 body 后需记住归属卡，close 时挂回（否则祖先 transform/overflow 会裁切 fixed） */
    const buyDdModalPortalOwner = new WeakMap();

    const restoreBuyDdModalToWrap = (modalEl) => {
      if (!(modalEl instanceof HTMLElement)) return;
      const owner = buyDdModalPortalOwner.get(modalEl);
      if (owner instanceof HTMLElement && modalEl.parentNode === document.body) {
        owner.appendChild(modalEl);
      }
    };

    const setBuyDdModalDomOpen = (modalEl, open) => {
      if (!(modalEl instanceof HTMLElement)) return;
      if (open) modalEl.setAttribute('data-na-buy-modal-open', '1');
      else modalEl.removeAttribute('data-na-buy-modal-open');
    };

    const mountBuyDdModalToBody = (modalEl, ownerWrap) => {
      if (!(modalEl instanceof HTMLElement) || !(ownerWrap instanceof HTMLElement)) return;
      if (!(mqBuyDdMobile && mqBuyDdMobile.matches)) return;
      buyDdModalPortalOwner.set(modalEl, ownerWrap);
      if (modalEl.parentNode !== document.body) {
        document.body.appendChild(modalEl);
      }
    };

    const clearBuyDdScrollLock = () => {
      try {
        document.documentElement.classList.remove('na-buy-dd-scroll-lock');
        document.body.classList.remove('na-buy-dd-scroll-lock');
      } catch (_) {}
    };

    const applyBuyDdScrollLockIfMobile = () => {
      if (mqBuyDdMobile && mqBuyDdMobile.matches) {
        try {
          document.documentElement.classList.add('na-buy-dd-scroll-lock');
          document.body.classList.add('na-buy-dd-scroll-lock');
        } catch (_) {}
      }
    };

    const clearDdHoverLeaveTimer = (wEl) => {
      if (!(wEl instanceof HTMLElement)) return;
      const tid = hoverLeaveTimers.get(wEl);
      if (tid != null) window.clearTimeout(tid);
      hoverLeaveTimers.delete(wEl);
    };

    /** @type {{ wrap: HTMLElement; toggle: HTMLElement; panel: HTMLElement; modal: HTMLElement | null; modalDismiss: HTMLElement | null; modalClose: HTMLElement | null }[]} */
    const buyDdInstances = [];
    wraps.forEach((wrap) => {
      if (!(wrap instanceof HTMLElement)) return;
      if (isTravelSceneClone(wrap)) return;
      const toggle = wrap.querySelector('[data-na-buy-dropdown-toggle]');
      const panel = wrap.querySelector('[data-na-buy-dropdown-panel]');
      const modal = wrap.querySelector('[data-na-buy-dropdown-modal]');
      if (!(toggle instanceof HTMLElement) || !(panel instanceof HTMLElement)) return;
      if (toggle.hasAttribute('disabled')) return;
      const modalDismiss =
        modal instanceof HTMLElement ? modal.querySelector('[data-na-buy-dropdown-modal-dismiss]') : null;
      const modalClose =
        modal instanceof HTMLElement ? modal.querySelector('[data-na-buy-dropdown-modal-close]') : null;
      buyDdInstances.push({
        wrap,
        toggle,
        panel,
        modal: modal instanceof HTMLElement ? modal : null,
        modalDismiss: modalDismiss instanceof HTMLElement ? modalDismiss : null,
        modalClose: modalClose instanceof HTMLElement ? modalClose : null,
      });
    });

    const closeAllInRoot = () => {
      buyDdInstances.forEach(({ wrap, toggle, panel, modal }) => {
        clearDdHoverLeaveTimer(wrap);
        if (modal) {
          setBuyDdModalDomOpen(modal, false);
          restoreBuyDdModalToWrap(modal);
        }
        wrap.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        if (panel.dataset.naDdMounted !== '1') {
          panel.hidden = true;
        }
      });
      clearBuyDdScrollLock();
    };

    const onBuyDdCrossToDesk = () => {
      if (mqBuyDdDesk && mqBuyDdDesk.matches) {
        closeAllInRoot();
      }
    };
    if (mqBuyDdDesk) {
      mqBuyDdDesk.addEventListener('change', onBuyDdCrossToDesk);
      cleanups.push(() => mqBuyDdDesk.removeEventListener('change', onBuyDdCrossToDesk));
    }

    buyDdInstances.forEach(({ wrap, toggle, panel, modal, modalDismiss, modalClose }) => {
      /* 首屏即关：移除原生 hidden，改由 is-open + CSS 过渡控制（克隆卡仍保留 hidden） */
      wrap.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      panel.removeAttribute('hidden');
      panel.dataset.naDdMounted = '1';

      const close = () => {
        clearDdHoverLeaveTimer(wrap);
        if (modal) {
          setBuyDdModalDomOpen(modal, false);
          restoreBuyDdModalToWrap(modal);
        }
        wrap.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        clearBuyDdScrollLock();
      };

      const open = () => {
        clearDdHoverLeaveTimer(wrap);
        closeAllInRoot();
        panel.dataset.naDdInteractive = '1';
        wrap.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        applyBuyDdScrollLockIfMobile();
        if (modal) {
          setBuyDdModalDomOpen(modal, true);
          mountBuyDdModalToBody(modal, wrap);
        }
      };

      if (prefersHoverOpen) {
        const onEnter = () => {
          clearDdHoverLeaveTimer(wrap);
          open();
        };
        const onLeave = () => {
          clearDdHoverLeaveTimer(wrap);
          const tid = window.setTimeout(() => {
            hoverLeaveTimers.delete(wrap);
            close();
          }, HOVER_LEAVE_MS);
          hoverLeaveTimers.set(wrap, tid);
        };
        wrap.addEventListener('mouseenter', onEnter);
        wrap.addEventListener('mouseleave', onLeave);
        cleanups.push(() => wrap.removeEventListener('mouseenter', onEnter));
        cleanups.push(() => wrap.removeEventListener('mouseleave', onLeave));

        /* 键盘：Tab 进入购买区时展开，离开整块区域后收起 */
        const onFocusIn = () => {
          open();
        };
        const onFocusOut = (e) => {
          const next = e.relatedTarget;
          if (next instanceof Node && wrap.contains(next)) return;
          if (next instanceof Node && modal && modal.contains(next)) return;
          close();
        };
        wrap.addEventListener('focusin', onFocusIn);
        wrap.addEventListener('focusout', onFocusOut);
        cleanups.push(() => wrap.removeEventListener('focusin', onFocusIn));
        cleanups.push(() => wrap.removeEventListener('focusout', onFocusOut));

        /* 精指针：以 hover 为主，click 作兜底（触控板/未触发 mouseenter 时仍可展开） */
        const onToggleClickHover = (e) => {
          e.stopPropagation();
          if (wrap.classList.contains('is-open')) close();
          else open();
        };
        toggle.addEventListener('click', onToggleClickHover);
        cleanups.push(() => toggle.removeEventListener('click', onToggleClickHover));
      } else {
        const onToggleClick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (wrap.classList.contains('is-open')) close();
          else open();
        };
        toggle.addEventListener('click', onToggleClick);
        cleanups.push(() => toggle.removeEventListener('click', onToggleClick));
      }

      const onModalDismiss = (e) => {
        e.preventDefault();
        e.stopPropagation();
        close();
      };
      if (modalDismiss) {
        modalDismiss.addEventListener('click', onModalDismiss);
        cleanups.push(() => modalDismiss.removeEventListener('click', onModalDismiss));
      }
      if (modalClose) {
        modalClose.addEventListener('click', onModalDismiss);
        cleanups.push(() => modalClose.removeEventListener('click', onModalDismiss));
      }
    });

    const onDocPointerDown = (e) => {
      const el = e.target instanceof Element ? e.target : null;
      if (!el || el.closest('[data-na-buy-dropdown]') || el.closest('[data-na-buy-dropdown-modal]')) return;
      closeAllInRoot();
    };
    document.addEventListener('pointerdown', onDocPointerDown, true);
    cleanups.push(() => document.removeEventListener('pointerdown', onDocPointerDown, true));

    const onKeyDown = (e) => {
      if (e.key === 'Escape') closeAllInRoot();
    };
    document.addEventListener('keydown', onKeyDown);
    cleanups.push(() => document.removeEventListener('keydown', onKeyDown));

    cleanups.push(() => {
      buyDdInstances.forEach(({ wrap, modal }) => {
        clearDdHoverLeaveTimer(wrap);
        if (modal) {
          setBuyDdModalDomOpen(modal, false);
          restoreBuyDdModalToWrap(modal);
        }
      });
      clearBuyDdScrollLock();
    });
  }

  function initNexodeAirTemplateFeatureSections(root) {
    const gsap = window.gsap;
    const ScrollTrigger = window.ScrollTrigger;
    const cleanups = [];
    const registered = [];
    const reduced =
      typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (gsap && ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
      try {
        const de = document.documentElement;
        if (de && de.dataset.ugNexodeAirTemplateScrollSnapFix !== '1') {
          de.dataset.ugNexodeAirTemplateScrollSnapFix = '1';
          de.style.scrollBehavior = 'auto';
        }
      } catch (_) {}
    }

    const ctx = { cleanups, registered, reduced };

    initNexodeAirKvNav(root, ctx);
    initWhenNexode65wAir65(root, ctx);
    initNexodeAirWhyAir(root, ctx);
    initNexodeAirEventScheduleModal(root, ctx);
    initNexodeAirLaunchCampaignGleam(root, ctx);
    initNexodeAirTvcModal(root, ctx);
    initNexodeAirTvcInlineVideo(root, ctx);
    initNexodeAirTemplateColorCompat(root, ctx);
    initNexodeTravelScene(root, ctx);
    initNexodeAirEditionsSwiper(root, ctx);
    initNexodeAirEditionsMoViewMore(root, ctx);
    initNexodeAirEditionsCards(root, ctx);
    initNexodeAirBuyDropdowns(root, ctx);
    initNexodeAirChargePromo(root, ctx);
    initNexodeTravelKit(root, ctx);
    initNexodeDesignCare(root, ctx);

    scheduleNexodeAirTemplateScrollTriggerRefresh();

    return function cleanup() {
      cleanups.forEach((fn) => {
        try {
          fn();
        } catch (_) {}
      });
      registered.forEach((st) => {
        try {
          st.kill();
        } catch (_) {}
      });
    };
  }

  if (typeof window !== 'undefined') {
    window.UgNexodeAirTemplateReveal = {
      defaults: REVEAL_DEFAULTS,
      init: initNexodeAirTemplateScrollReveal,
      refresh: refreshNexodeAirTemplateScrollReveal
    };
  }

  function validateEmailFormat(email) {
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      String(email).toLowerCase()
    );
  }

  class NexodeAirTemplateSection extends HTMLElement {
    constructor() {
      super();
      this._onVideoResize = null;
      this._kvResizeRaf = 0;
      this._naRevealCleanup = null;
      this._naFeatureCleanup = null;
    }

    connectedCallback() {
      if (this.dataset.naInited === '1') {
        return;
      }
      this.dataset.naInited = '1';

      this._naRevealCleanup = initNexodeAirTemplateScrollReveal(this);
      this._naFeatureCleanup = initNexodeAirTemplateFeatureSections(this);

      this.initKvVideo();
      this.initEmailBlocks();
    }

    disconnectedCallback() {
      if (this._kvResizeRaf) {
        window.cancelAnimationFrame(this._kvResizeRaf);
        this._kvResizeRaf = 0;
      }
      if (this._onVideoResize) {
        window.removeEventListener('resize', this._onVideoResize);
        this._onVideoResize = null;
      }
      this.dataset.naVideoResizeBound = '0';

      if (typeof this._naRevealCleanup === 'function') {
        this._naRevealCleanup();
        this._naRevealCleanup = null;
      }

      if (typeof this._naFeatureCleanup === 'function') {
        this._naFeatureCleanup();
        this._naFeatureCleanup = null;
      }
    }

    initKvVideo() {
      const posterImg = this.querySelector('.ug-nexode-air-template__kv-poster');
      let lastIsMobile = null;

      const sync = () => {
        const isMobile = window.matchMedia(MOBILE_MQ).matches;
        if (lastIsMobile !== null && lastIsMobile === isMobile) {
          return;
        }
        lastIsMobile = isMobile;

        const active = isMobile
          ? this.querySelector('.ug-nexode-air-template__kv-video--mo')
          : this.querySelector('.ug-nexode-air-template__kv-video--pc');
        const inactive = isMobile
          ? this.querySelector('.ug-nexode-air-template__kv-video--pc')
          : this.querySelector('.ug-nexode-air-template__kv-video--mo');

        if (inactive instanceof HTMLVideoElement) {
          try {
            inactive.pause();
            inactive.preload = 'none';
          } catch (_) {}
          inactive.classList.remove('is-visible');
        }
        if (!(active instanceof HTMLVideoElement)) {
          return;
        }

        try {
          active.preload = 'auto';
        } catch (_) {}

        const srcEl = active.querySelector('source');
        const src = srcEl && srcEl.getAttribute('src');
        if (!src || src.trim() === '') {
          return;
        }

        const tryPlay = () => {
          active.classList.add('is-visible');
          if (posterImg) {
            posterImg.classList.add('is-hidden');
          }
          naPlayBufferedInlineVideo(active);
        };

        if (active.readyState >= 3) {
          tryPlay();
        } else {
          active.addEventListener('canplay', tryPlay, { once: true });
          active.addEventListener('loadeddata', tryPlay, { once: true });
          try {
            active.load();
          } catch (_) {}
        }
      };

      const scheduleSync = () => {
        if (this._kvResizeRaf) {
          window.cancelAnimationFrame(this._kvResizeRaf);
        }
        this._kvResizeRaf = window.requestAnimationFrame(() => {
          this._kvResizeRaf = 0;
          sync();
        });
      };

      scheduleSync();

      if (this.dataset.naVideoResizeBound === '1') {
        return;
      }
      this.dataset.naVideoResizeBound = '1';
      this._onVideoResize = scheduleSync;
      window.addEventListener('resize', this._onVideoResize, { passive: true });
    }

    initEmailBlocks() {
      const blocks = this.querySelectorAll('.ug-nexode-air-template__email[data-na-email]');
      blocks.forEach((block) => {
        this.bindEmailBlock(block);
      });
    }

    bindEmailBlock(block) {
      if (!(block instanceof HTMLElement)) {
        return;
      }
      if (block.dataset.naEmailInited === '1') {
        return;
      }
      block.dataset.naEmailInited = '1';

      const submitBtn = block.querySelector('.ug-nexode-air-template__email-submit');
      const input = block.querySelector('.ug-nexode-air-template__email-input');
      const privacyCheckbox = block.querySelector('.ug-nexode-air-template__email-checkbox');
      const errorMsg = block.querySelector('.ug-nexode-air-template__email-error');
      const successMsg = block.querySelector('.ug-nexode-air-template__email-message');

      const formId = block.getAttribute('data-form-id') || '';
      const successText = block.getAttribute('data-success-text') || 'Thanks for subscribing!';
      const failText = block.getAttribute('data-fail-text') || 'Subscription failed, please try again later.';
      const privacyError = block.getAttribute('data-privacy-error') || 'Please agree to the privacy policy.';
      const emailError = block.getAttribute('data-email-error') || 'Please enter a valid email address.';

      if (!(submitBtn instanceof HTMLButtonElement) || !(input instanceof HTMLInputElement)) {
        return;
      }

      const showError = (msg) => {
        if (errorMsg instanceof HTMLElement) {
          errorMsg.textContent = msg;
          errorMsg.style.display = 'block';
        }
        if (successMsg instanceof HTMLElement) {
          successMsg.style.display = 'none';
        }
      };

      const showSuccess = (msg) => {
        if (successMsg instanceof HTMLElement) {
          successMsg.textContent = msg;
          successMsg.style.display = 'block';
        }
        if (errorMsg instanceof HTMLElement) {
          errorMsg.style.display = 'none';
        }
      };

      const trackSubscription = (isSuccess) => {
        const w = window;
        if (!w.ugGa4Track || typeof w.ugGa4Track.subscriptionEvent !== 'function') {
          return;
        }
        try {
          w.ugGa4Track.subscriptionEvent({ isSuccess, position: 'nexode-air-template' });
        } catch (_) {}
      };

      submitBtn.addEventListener('click', async () => {
        const emailVal = input.value.trim();

        if (!validateEmailFormat(emailVal)) {
          showError(emailError);
          return;
        }

        if (privacyCheckbox instanceof HTMLInputElement && !privacyCheckbox.checked) {
          showError(privacyError);
          return;
        }

        if (errorMsg instanceof HTMLElement) {
          errorMsg.style.display = 'none';
        }
        if (successMsg instanceof HTMLElement) {
          successMsg.style.display = 'none';
        }

        if (submitBtn.classList.contains('loading')) {
          return;
        }

        submitBtn.classList.add('loading');

        try {
          const response = await fetch(FORM_SUBMIT_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              email: emailVal,
              accepts_marketing:
                privacyCheckbox instanceof HTMLInputElement && privacyCheckbox.checked ? 'on' : 'off',
              form_id: formId
            })
          });

          let data = null;
          try {
            data = await response.json();
          } catch (_) {
            showError(failText);
            trackSubscription(false);
            return;
          }

          const isSuccess = data && data.status === 'success';
          if (isSuccess) {
            input.value = '';
            showSuccess(successText);
          } else {
            const serverMsg =
              (data && data.errors && data.errors.email && data.errors.email[0]) ||
              (data && data.message) ||
              failText;
            showError(serverMsg);
          }
          trackSubscription(!!isSuccess);
        } catch (_) {
          showError(failText);
          trackSubscription(false);
        } finally {
          submitBtn.classList.remove('loading');
        }
      });

      input.addEventListener('keydown', (e) => {
        if (e instanceof KeyboardEvent && e.key === 'Enter') {
          e.preventDefault();
          submitBtn.click();
        }
      });
    }
  }

  customElements.define(TAG_NAME, NexodeAirTemplateSection);
})();
